const CONFIG = {
    mobileBreakpoint: 1200,
    maxMobileLinesCount: 999,
    maxDesktopLinesCount: 999,

    defaultPlaceholderText: 'Your Text',
    baseFontSize: 38,
    minFontSize: 20,
    textBoundingRatioMobile: { width: 0.8, height: 0.7 },
    textBoundingRatioDesktop: { width: 0.85, height: 0.75 },

    rgbCycleSpeed: 500,
    rgbColorSequence: ['#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#0000FF', '#4B0082', '#9400D3'],

    basePrice: 90,
    rgbSurcharge: 50,
    outdoorSurcharge: 65,

    enableBaseDiscount: true,
    basePromotionPercentage: 0.20,

    productCostPerInchStandard: 0.2519,
    productCostPerInchRGB: 0.2947,
    shippingCostPerInch: 0.25,
    usdToCadMultiplier: 1.42,
    localShippingCostUSD: 45 / 1.42,
    minProfitPercentage: 0.35,
    minProfitUSD: 100 / 1.42,
    minimumPriceFloor: 90,
    maximumCustomWidth: 200,
    maximumCustomHeight: 100,

    premiumFontsDouble: ['loveneon', 'scifi', 'mayfair'],

    planScalingFactor: 1.3,
    planNames: ['Mini', 'Small', 'Medium', 'Large', 'XL', 'XXL', 'XXXL', '4XL'],

    couponApiEndpoint: '',

    lineHeightMultipliers: {
        // Measured from each production font's real ascender/descender bounds.
        // Every value includes at least 0.26em of clear space between neon lines.
        'Barcelona': 1.95,
        'Alexa': 1.35,
        'Bayview': 1.35,
        'Amsterdam': 1.35,
        'Greenworld': 1.35,
        'NewCursive': 1.35,
        'Vintage': 1.35,
        'Venetian': 1.55,
        'Amanda': 1.65,
        'Austin': 1.35,
        'Beachfront': 1.55,
        'Chelsea': 1.4,
        'Freehand': 1.45,
        'Freespirit': 2.55,
        'LoveNote': 1.35,
        'Neonscript': 1.8,
        'Northshore': 1.75,
        'Photogenic': 1.7,
        'Royalty': 1.8,
        'Rocket': 1.9,
        'Signature': 1.35,
        'Sorrento': 2.1,
        'WildScript': 1.4,
        'Avante': 1.35,
        'Buttercup': 1.35,
        'ClassicType': 1.35,
        'Typewriter': 1.35,
        'Melbourne': 1.35,
        'NeoTokyo': 1.35,
        'Monaco': 1.35,
        'Waikiki': 1.35,
        'Bellview': 1.35,
        'LoveNeon': 1.35,
        'Marquee': 1.35,
        'Mayfair': 1.35,
        'NeonGlow': 1.35,
        'NeonLite': 1.35,
        'Neontrace': 1.35,
        'Nevada': 1.35,
        'SciFi': 1.35
    }
};

function isFrenchDesigner() {
    return (document.documentElement.lang || '').toLowerCase().startsWith('fr');
}

function getDesignerCopy() {
    if (isFrenchDesigner()) {
        return {
            apply: 'Appliquer',
            remove: 'Retirer',
            validating: 'Validation…',
            preparing: 'Préparation…',
            processing: 'Traitement…',
            next: 'Suivant',
            previewAndBuy: 'Aperçu et achat',
            enterCustomSize: 'Saisir une taille personnalisée',
            selectSize: 'Sélectionner la taille',
            selectColor: 'Choisir une couleur',
            customSizeNote: (minWidth, minHeight) => `Les proportions sont verrouillées. Largeur minimale : ${minWidth} po. Hauteur minimale : ${minHeight} po. Les dimensions personnalisées dépendent de la quantité de néon DEL requise.`,
            customSizeRange: (minWidth, minHeight) => `Entrez une largeur de ${minWidth} à ${CONFIG.maximumCustomWidth} po et une hauteur de ${minHeight} à ${CONFIG.maximumCustomHeight} po.`,
            customSizeAspect: (dimension, maximum) => `Les proportions de ce motif produisent ${dimension} po, au-delà de la limite de ${maximum} po. Réduisez la dimension ou demandez un devis personnalisé.`,
            couponInvalid: 'Ce code est invalide ou expiré.',
            couponNetwork: 'Impossible de vérifier le code pour le moment. Réessayez.',
            couponApplied: code => `Le code « ${code} » a été appliqué.`,
            orderKicker: 'Votre enseigne personnalisée',
            orderTitle: 'Résumé de la commande',
            orderIntro: 'Vérifiez votre design, les options choisies et le total avant de passer à la caisse.',
            closeOrder: 'Fermer le résumé de la commande',
            selectedFeatures: 'Options choisies',
            configuredSubtotal: 'Sous-total de l’enseigne configurée',
            baseDiscount: 'Rabais de base',
            coupon: 'Code promo',
            off: 'de rabais',
            total: 'Total',
            continueEditing: 'Continuer la modification',
            buyNow: 'Acheter maintenant',
            checkoutTextRequired: 'Saisissez le texte de votre enseigne avant de passer à la caisse.',
            checkoutError: 'Un problème est survenu lors de la création de votre commande. Réessayez.',
            featureLabels: {
                text: 'Texte', font: 'Police', color: 'Couleur', size: 'Taille', location: 'Emplacement',
                shape: 'Forme', backboard: 'Acrylique', power: 'Adaptateur', extra: 'Option'
            },
            locations: { indoor: 'Intérieur', outdoor: 'Extérieur' },
            shapes: {
                'cut-to-shape': 'Découpe à la forme',
                'cut-to-letter': 'Découpe aux lettres',
                'cut-rectangle': 'Rectangle',
                'cut-to-circle': 'Découpe en cercle',
                'cut-to-cirlce': 'Découpe en cercle'
            },
            backboards: {
                clear: 'Acrylique transparent standard',
                'glossy-white': 'Acrylique blanc lustré',
                'glossy-black': 'Acrylique noir lustré',
                silver: 'Acrylique argent',
                gold: 'Acrylique or'
            },
            powerAdapters: { canada: 'Canada (110 V)' },
            extras: {
                hanging: 'Fixation murale', remote: 'Télécommande et gradateur', waterproof: 'Protection imperméable'
            },
            colors: {
                'Warm White': 'Blanc chaud', White: 'Blanc', Red: 'Rouge', 'Lemon Yellow': 'Jaune citron',
                'Golden Yellow': 'Jaune doré', Orange: 'Orange', Pink: 'Rose', 'Deep Pink': 'Rose foncé',
                Purple: 'Violet', 'Royal Blue': 'Bleu royal', 'Ice Blue': 'Bleu glacé', Mint: 'Menthe',
                Teal: 'Sarcelle', Green: 'Vert', 'Tropical Blue': 'Bleu tropical',
                'RGB Color Changing': 'RGB à couleurs changeantes', Custom: 'Personnalisée'
            },
            exportSvg: 'Exporter en SVG (vectoriel)',
            exportPng: 'Exporter en PNG (haute résolution)',
            noCanvas: 'Aperçu introuvable',
            addTextBeforeExport: 'Ajoutez du texte à votre enseigne avant l’exportation.',
            exportFailed: 'Impossible de générer l’aperçu.',
            fontCount: count => `Parcourir toutes les polices néon (${count})`,
            limitedTime: percentage => `${percentage} % de rabais pour une durée limitée`
        };
    }

    return {
        apply: 'Apply',
        remove: 'Remove',
        validating: 'Validating…',
        preparing: 'Preparing…',
        processing: 'Processing…',
        next: 'Next',
        previewAndBuy: 'Preview & Buy',
        enterCustomSize: 'Enter custom size',
        selectSize: 'Select size',
        selectColor: 'Select colour',
        customSizeNote: (minWidth, minHeight) => `Aspect ratio is locked to maintain proportions. Minimum width: ${minWidth} inches. Minimum height: ${minHeight} inches. Custom sizes are based on the LED neon required.`,
        customSizeRange: (minWidth, minHeight) => `Enter a width from ${minWidth} to ${CONFIG.maximumCustomWidth} inches and a height from ${minHeight} to ${CONFIG.maximumCustomHeight} inches.`,
        customSizeAspect: (dimension, maximum) => `This design’s locked proportions produce ${dimension} inches, above the ${maximum}-inch limit. Reduce the dimension or request a custom quote.`,
        couponInvalid: 'This code is invalid or expired.',
        couponNetwork: 'We could not validate the code right now. Please try again.',
        couponApplied: code => `Coupon “${code}” applied successfully.`,
        orderKicker: 'Your custom sign',
        orderTitle: 'Order Summary',
        orderIntro: 'Review your design, selected features and total before checkout.',
        closeOrder: 'Close order summary',
        selectedFeatures: 'Selected Features',
        configuredSubtotal: 'Configured sign subtotal',
        baseDiscount: 'Base Discount',
        coupon: 'Coupon',
        off: 'off',
        total: 'Total',
        continueEditing: 'Continue Editing',
        buyNow: 'Buy Now',
        checkoutTextRequired: 'Please enter your sign text before proceeding to checkout.',
        checkoutError: 'There was a problem creating your order. Please try again.',
        featureLabels: {
            text: 'Text', font: 'Font', color: 'Colour', size: 'Size', location: 'Location',
            shape: 'Shape', backboard: 'Backboard', power: 'Power adapter', extra: 'Extra'
        },
        locations: { indoor: 'Indoor', outdoor: 'Outdoor' },
        shapes: {
            'cut-to-shape': 'Cut to Shape',
            'cut-to-letter': 'Cut to Letter',
            'cut-rectangle': 'Rectangle',
            'cut-to-circle': 'Cut to Circle',
            'cut-to-cirlce': 'Cut to Circle'
        },
        backboards: {
            clear: 'Standard Clear Acrylic',
            'glossy-white': 'Glossy White Acrylic',
            'glossy-black': 'Glossy Black Acrylic',
            silver: 'Silver Acrylic',
            gold: 'Gold Acrylic'
        },
        powerAdapters: { canada: 'Canada (110V)' },
        extras: {
            hanging: 'Wall mounting', remote: 'Remote and dimmer', waterproof: 'Waterproof protection'
        },
        colors: {},
        exportSvg: 'Export as SVG (Vector)',
        exportPng: 'Export as PNG (High-Res)',
        noCanvas: 'Preview not found',
        addTextBeforeExport: 'Please add text to your sign before exporting.',
        exportFailed: 'Failed to generate preview.',
        fontCount: count => `Browse All Neon Fonts (${count})`,
        limitedTime: percentage => `${percentage}% off for a limited time`
    };
}




const appState = {
    text: '',
    userHasEnteredText: false,

    fontFamily: "Barcelona",
    fontKey: 'Barcelona',
    fontSizePx: CONFIG.baseFontSize,
    lineHeightPx: CONFIG.lineHeightMultipliers['Barcelona'] || 1.5,

    colorValue: '#FFFFFF',
    colorName: 'White',
    rgbSurcharge: 0,
    rgbMode: false,
    rgbAnimationTimer: null,

    type: 'indoor',
    outdoorSurcharge: 0,

    backboard: 'clear',
    cutTo: 'cut-to-shape',
    cutToPrice: 0,

    extras: [],

    plan: {
        id: 'mini',
        name: 'Mini',
        widthIn: 23,
        heightIn: 10,
        price: 308.99
    },

    totalPrice: 308.99,
    discountPrice: 247.19,
    originalDiscountPrice: 247.19,
    discountApplied: false,
    activeDiscount: null,
    discountCode: null,

    svgMarkup: '',
    previewPngData: '',
    svgWidthPx: 800,
    svgHeightPx: 600,

    measuredWidthIn: 17,
    measuredHeightIn: 10,

    currentStep: 1,
    inputType: 'text',
    logoFile: null,
    logoDataUrl: null,
    multicolor: false,
    characterColors: {},
    selectedCharIndex: null,
    themeMode: 'dark',
    neonGlowEnabled: true,
    generatedPlans: []
};

const canvasInstances = {};
const animationHandles = {};

function roundCurrency(value) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

// Minimum dimensions for custom sizing (will be updated when cards regenerate)
let MINIMUM_WIDTH = 17;
let MINIMUM_HEIGHT = 10;

// Font loading utility - ensures fonts are loaded before rendering
async function ensureFontLoaded(fontFamily) {
    // Check if document.fonts API is available
    if (!document.fonts) {
        // Fallback: wait a bit for fonts to load
        return new Promise(resolve => setTimeout(resolve, 500));
    }

    try {
        // Wait for the specific font to be loaded
        await document.fonts.load(`38px ${fontFamily}`);
        // Also wait for all fonts to be ready (in case of dependencies)
        await document.fonts.ready;
        return true;
    } catch (error) {
        console.warn(`Font ${fontFamily} failed to load, using fallback:`, error);
        // Wait a bit anyway to give fonts time to load
        return new Promise(resolve => setTimeout(resolve, 500));
    }
}




function initializeActiveStates() {
    const defaultFontCard = document.querySelector('.font-card[data-font="barcelona"]');
    const defaultFontItem = document.querySelector('.font-list-item[data-font="barcelona"]');
    if (defaultFontCard) {
        defaultFontCard.classList.add('active');
    }

    if (defaultFontItem) {
        defaultFontItem.classList.add('active');
    }

    const defaultColor = document.querySelector('.color-option[data-color="#FFFFFF"]');
    if (defaultColor && !defaultColor.classList.contains('active')) {
        document.querySelectorAll('.color-option').forEach(opt => opt.classList.remove('active'));
        defaultColor.classList.add('active');
    }

    const defaultBackboard = document.querySelector('.backboard-color-option input[value="clear"]');
    if (defaultBackboard) {
        const parent = defaultBackboard.closest('.backboard-color-option');
        if (parent) parent.classList.add('active');
    }

    const defaultPower = document.querySelector('.radio-pill input[value="canada"]');
    if (defaultPower) {
        const parent = defaultPower.closest('.radio-pill');
        if (parent) parent.classList.add('active');
    }
}

function normalizeDesignerControls() {
    document.querySelectorAll('.neon-tool-scope button:not([type])').forEach(button => {
        button.type = 'button';
    });

    const trigger = document.getElementById('fontLibraryTrigger');
    const triggerLabel = trigger?.querySelector('span');
    if (triggerLabel) {
        const uniqueFonts = new Set(
            [...document.querySelectorAll('.font-list-item[data-font]')]
                .map(item => item.dataset.font)
                .filter(Boolean)
        );
        triggerLabel.textContent = getDesignerCopy().fontCount(uniqueFonts.size);
    }
}




let hasInitializedDesigner = false;
let initialRenderComplete = false;

function runWhenIdle(fn, { timeout = 1200 } = {}) {
    try {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(fn, { timeout });
            return;
        }
    } catch (e) { }
    setTimeout(fn, 0);
}

let previewAndPriceUpdatePending = false;
function schedulePreviewAndPriceUpdate() {
    if (previewAndPriceUpdatePending) return;
    previewAndPriceUpdatePending = true;
    requestAnimationFrame(() => {
        previewAndPriceUpdatePending = false;
        renderAllPreviews();
        recalculateTotalPrice();
        initialRenderComplete = true;
    });
}

document.addEventListener('DOMContentLoaded', () => {
    // Keep immediate work very small to reduce blocking on initial render.
    normalizeDesignerControls();
    attachEventListeners();
    initializeActiveStates();

    runWhenIdle(() => {
        if (hasInitializedDesigner) return;
        hasInitializedDesigner = true;

        setupCanvases();
        generateInitialPlans();

        const initialDimensions = calculateIntelligentDimensions(appState.text);
        regenerateSizeCards(initialDimensions.widthInches, initialDimensions.heightInches);

        // Ensure default font (Barcelona) is loaded before rendering
        ensureFontLoaded('Barcelona').then(() => {
            schedulePreviewAndPriceUpdate();
        }).catch(err => {
            console.warn('Font loading failed, rendering with fallback:', err);
            schedulePreviewAndPriceUpdate();
        });
    });
});

// Additional render on window load to ensure everything is ready after refresh
window.addEventListener('load', () => {
    // Avoid doing extra work during the busiest load period unless it is needed.
    if (initialRenderComplete) return;
    const canvasIds = Object.keys(canvasInstances);
    if (canvasIds.length === 0) return;

    // Reset all canvas viewports to ensure proper centering after refresh
    canvasIds.forEach(canvasId => {
        const canvas = canvasInstances[canvasId];
        if (canvas) {
            canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
        }
    });

    requestAnimationFrame(() => {
        renderAllPreviews();
        initialRenderComplete = true;
    });
});

function setupCanvases() {
    for (let step = 1; step <= 4; step++) {
        const canvasId = step === 1 ? 'neonCanvas' : `neonCanvas${step}`;
        const elem = document.getElementById(canvasId);

        if (elem) {
            canvasInstances[canvasId] = new fabric.Canvas(canvasId, {
                width: 800,
                height: 600,
                backgroundColor: 'transparent',
                selection: false,
                renderOnAddRemove: false,
                skipTargetFind: false,
                // Disable interactive features to prevent passive listener violations
                interactive: true,
                // Disable default zoom with mouse wheel to prevent passive listener issues
                allowTouchScrolling: true,
                stopContextMenu: true,
                fireRightClick: false,
                // Performance optimizations
                enableRetinaScaling: false,
                imageSmoothingEnabled: true
            });

            // Disable wheel zoom to prevent passive listener violations
            canvasInstances[canvasId].off('mouse:wheel');

            canvasInstances[canvasId].on('mouse:down', function (options) {
                handleCanvasClick(canvasId, options);
            });
        }
    }
}


function handleCanvasClick(canvasId, options) {
    if (!appState.multicolor) return;

    const canvas = canvasInstances[canvasId];
    if (!canvas) return;

    const pointer = canvas.getPointer(options.e);
    const characterObjects = canvas.getObjects().filter(obj => obj.charIndex !== undefined);

    for (let obj of characterObjects) {
        const bounds = obj.getBoundingRect();

        if (pointer.x >= bounds.left && pointer.x <= bounds.left + bounds.width &&
            pointer.y >= bounds.top && pointer.y <= bounds.top + bounds.height) {
            appState.selectedCharIndex = obj.charIndex;
            renderAllPreviews();
            showColorPopup(canvasId, obj);
            return;
        }
    }

    appState.selectedCharIndex = null;
    renderAllPreviews();
    hideColorPopup();
}


function showColorPopup(canvasId, charObj) {
    const canvasElement = document.getElementById(canvasId);
    if (!canvasElement) return;

    hideColorPopup();

    const wrapper = canvasElement.closest('.canvas-wrapper');
    if (!wrapper) return;

    const popup = document.createElement('div');
    popup.className = 'character-color-popup';
    popup.id = 'characterColorPopup';

    const title = document.createElement('div');
    title.className = 'popup-title';
    const copy = getDesignerCopy();
    title.textContent = copy.selectColor.toUpperCase();
    popup.appendChild(title);

    const colorsGrid = document.createElement('div');
    colorsGrid.className = 'popup-colors';


    const colors = [
        { color: '#FFF8DC', name: 'Warm White' },
        { color: '#FFFFFF', name: 'White' },
        { color: '#FF0000', name: 'Red' },
        { color: '#FFF44F', name: 'Lemon Yellow' },
        { color: '#FFD700', name: 'Golden Yellow' },
        { color: '#FF8C00', name: 'Orange' },
        { color: '#FFC0CB', name: 'Pink' },
        { color: '#FF1493', name: 'Deep Pink' },
        { color: '#9B30FF', name: 'Purple' },
        { color: '#4169E1', name: 'Royal Blue' },
        { color: '#87CEEB', name: 'Ice Blue' },
        { color: '#98FF98', name: 'Mint' },
        { color: '#00CED1', name: 'Teal' },
        { color: '#00FF00', name: 'Green' },
        { color: '#1E90FF', name: 'Tropical Blue' }
    ];

    const currentColor = appState.characterColors[appState.selectedCharIndex] || appState.colorValue;

    colors.forEach(({ color, name }) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'popup-color-btn';
        btn.setAttribute('data-color', color);
        btn.setAttribute('title', copy.colors[name] || name);
        btn.setAttribute('aria-label', copy.colors[name] || name);

        const colorSwatch = document.createElement('div');
        colorSwatch.className = 'popup-color-swatch';
        colorSwatch.style.background = color;

        const colorName = document.createElement('span');
        colorName.className = 'popup-color-name';
        colorName.textContent = copy.colors[name] || name;

        btn.appendChild(colorSwatch);
        btn.appendChild(colorName);

        if (color === currentColor) {
            btn.classList.add('active');
        }

        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (appState.selectedCharIndex !== null) {
                appState.characterColors[appState.selectedCharIndex] = color;
                renderAllPreviews();


                popup.querySelectorAll('.popup-color-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
            }
        });

        colorsGrid.appendChild(btn);
    });

    popup.appendChild(colorsGrid);


    const customColorBtn = document.createElement('button');
    customColorBtn.type = 'button';
    customColorBtn.className = 'popup-color-btn custom-color-btn';
    customColorBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-left: 8px;">
            <path d="M8 3V13M3 8H13" stroke="#00FF00" stroke-width="2" stroke-linecap="round"/>
        </svg>
    `;


    const customColorInput = document.createElement('input');
    customColorInput.type = 'color';
    customColorInput.className = 'popup-custom-color-input';
    customColorInput.value = currentColor;

    customColorBtn.appendChild(customColorInput);


    customColorBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        customColorInput.click();
    });


    customColorInput.addEventListener('input', (e) => {
        e.stopPropagation();
        const selectedColor = e.target.value;

        if (appState.selectedCharIndex !== null) {
            appState.characterColors[appState.selectedCharIndex] = selectedColor;
            renderAllPreviews();


            popup.querySelectorAll('.popup-color-btn').forEach(b => b.classList.remove('active'));
        }
    });

    // colorsGrid.appendChild(customColorBtn);


    wrapper.appendChild(popup);


    const bounds = charObj.getBoundingRect();
    const canvasRect = canvasElement.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();


    const popupLeft = bounds.left + (bounds.width / 2) - (popup.offsetWidth / 2);
    const popupTop = bounds.top - popup.offsetHeight - 20;


    const finalLeft = Math.max(10, Math.min(popupLeft, canvasRect.width - popup.offsetWidth - 10));
    const finalTop = Math.max(10, popupTop);

    popup.style.left = `${finalLeft}px`;
    popup.style.top = `${finalTop}px`;


    setTimeout(() => {
        document.addEventListener('click', handlePopupOutsideClick);
    }, 100);
}

function hideColorPopup() {
    const popup = document.getElementById('characterColorPopup');
    if (popup) {
        popup.remove();
    }
    document.removeEventListener('click', handlePopupOutsideClick);
}

function handlePopupOutsideClick(e) {
    const popup = document.getElementById('characterColorPopup');
    if (popup && !popup.contains(e.target)) {
        const canvas = e.target.closest('canvas');
        if (!canvas) {
            hideColorPopup();
        }
    }
}




function attachEventListeners() {
    const textInput = document.getElementById('neonText');
    if (textInput) {
        textInput.addEventListener('input', handleTextInput);
    }

    attachFontListeners();
    attachColorListeners();
    attachPlanListeners();
    attachLocationListeners();
    attachShapeListeners();
    attachExtrasListeners();
    attachStepNavigationListeners();
    attachPreviewControlListeners();
    attachDiscountListeners();
    attachCheckoutListener();
}




function handleTextInput(event) {
    let inputText = event.target.value.trim();

    appState.text = inputText || CONFIG.defaultPlaceholderText;
    appState.userHasEnteredText = inputText.length > 0;
    appState.lineHeightPx = getLineHeightMultiplier(appState.fontFamily, appState.text);
    if (appState.userHasEnteredText) {
        clearSignTextError();
    }

    const dimensions = calculateIntelligentDimensions(appState.text);

    appState.plan.widthIn = dimensions.widthInches;
    appState.plan.heightIn = dimensions.heightInches;

    regenerateSizeCards(dimensions.widthInches, dimensions.heightInches);
    recalculatePlanPrice();
    schedulePreviewAndPriceUpdate();
}

function getLineHeightMultiplier(fontFamily = appState.fontFamily, text = appState.text) {
    const fallbackMultiplier = CONFIG.lineHeightMultipliers[fontFamily] || 1.5;
    const lines = String(text || '').split('\n');

    if (lines.length < 2 || !document.fonts || !document.fonts.check(`100px "${fontFamily}"`)) {
        return fallbackMultiplier;
    }

    const context = document.createElement('canvas').getContext('2d');
    if (!context) return fallbackMultiplier;

    context.font = `100px "${fontFamily}"`;
    const visibleGapAt100Px = 19;
    let requiredMultiplier = 0;

    for (let index = 0; index < lines.length - 1; index += 1) {
        if (!lines[index].trim() || !lines[index + 1].trim()) {
            requiredMultiplier = Math.max(requiredMultiplier, fallbackMultiplier);
            continue;
        }

        const currentMetrics = context.measureText(lines[index] || ' ');
        const nextMetrics = context.measureText(lines[index + 1] || ' ');
        const currentDescent = currentMetrics.actualBoundingBoxDescent;
        const nextAscent = nextMetrics.actualBoundingBoxAscent;

        if (!Number.isFinite(currentDescent) || !Number.isFinite(nextAscent)) {
            return fallbackMultiplier;
        }

        requiredMultiplier = Math.max(
            requiredMultiplier,
            (currentDescent + nextAscent + visibleGapAt100Px) / 100
        );
    }

    // Round up so the visible gap never falls below the target because of
    // fractional pixel measurements. Do not cap the result at the fallback:
    // accented capitals can legitimately exceed a font's usual line box.
    const fittedMultiplier = Math.ceil(requiredMultiplier * 100) / 100;
    return Math.min(3, Math.max(0.65, fittedMultiplier));
}

function getSignTextCopy() {
    const copy = getDesignerCopy();
    return {
        required: isFrenchDesigner()
            ? 'Saisissez le texte de votre enseigne avant de continuer.'
            : 'Enter the text for your sign before continuing.',
        preparing: copy.preparing
    };
}

function clearSignTextError() {
    const textInput = document.getElementById('neonText');
    const error = document.getElementById('neonTextError');
    if (textInput) {
        textInput.removeAttribute('aria-invalid');
        textInput.removeAttribute('aria-describedby');
    }
    if (error) error.remove();
}

function validateSignText({ focus = false } = {}) {
    const textInput = document.getElementById('neonText');
    const inputText = textInput ? textInput.value.trim() : '';

    if (inputText) {
        appState.text = inputText;
        appState.userHasEnteredText = true;
        appState.lineHeightPx = getLineHeightMultiplier(appState.fontFamily, appState.text);
        clearSignTextError();
        return true;
    }

    appState.userHasEnteredText = false;
    if (isMobileDecisionFlowActive() && mobileDecisionIndex !== 0) {
        activateMobileDecision(0);
    } else if (appState.currentStep !== 1) {
        navigateToStep(1);
    }

    if (!textInput) return false;

    let error = document.getElementById('neonTextError');
    if (!error) {
        error = document.createElement('p');
        error.id = 'neonTextError';
        error.className = 'neon-text-error';
        error.setAttribute('role', 'alert');
        textInput.closest('.input-row')?.insertAdjacentElement('afterend', error);
    }
    error.textContent = getSignTextCopy().required;
    textInput.setAttribute('aria-invalid', 'true');
    textInput.setAttribute('aria-describedby', error.id);

    if (focus) {
        requestAnimationFrame(() => {
            textInput.focus({ preventScroll: true });
            textInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
    }
    return false;
}

function calculateIntelligentDimensions(text) {
    // Matching neonText.js drawTextWithMeasurement logic exactly

    if (!text || text.trim() === '') {
        return { widthInches: 17, heightInches: 10 };
    }

    const lines = text.split('\n');
    const fontFamily = appState.fontFamily || 'Barcelona';
    let fontSize = 60; // Start at neonObject.fontSize (60px), same as neonText.js line 200/639

    // SVG dimensions matching appState (neonText.js uses actual SVG rect)
    const svgWidth = appState.svgWidthPx || 800;
    const svgHeight = appState.svgHeightPx || 600;

    // Bounding box ratios matching neonText.js lines 679-682
    const isMobile = window.innerWidth <= 767;
    const targetWidthRatio = isMobile ? 0.42 : 0.9;
    const targetHeightRatio = isMobile ? 0.14 : 0.9;
    const boundingBoxWidth = svgWidth * targetWidthRatio;
    const boundingBoxHeight = svgHeight * targetHeightRatio;

    const lineHeightMultiplier = getLineHeightMultiplier(fontFamily, text);

    // Create a canvas for measuring text (neonText.js lines 656-659)
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // getTextMetrics matching neonText.js lines 662-673 (no fallback values)
    function getTextMetrics(t, fs) {
        context.font = `${fs}px ${fontFamily}`;
        const metrics = context.measureText(t);
        return {
            width: metrics.width,
            ascent: metrics.actualBoundingBoxAscent,
            descent: metrics.actualBoundingBoxDescent,
        };
    }

    // calculateTextLayout matching neonText.js lines 686-714
    function calculateTextLayout(testFontSize) {
        const layout = { maxX: [], minX: [], maxY: [], minY: [] };
        let currentY = svgHeight * 0.10;
        lines.forEach((line) => {
            const { width: lineWidth, ascent, descent } = getTextMetrics(line, testFontSize);
            const xPos = (svgWidth - lineWidth) / 2;
            const yPos = currentY + ascent;
            layout.maxX.push(xPos + lineWidth);
            layout.minX.push(xPos);
            layout.maxY.push(yPos + descent);
            layout.minY.push(currentY);
            currentY += testFontSize * lineHeightMultiplier;
        });
        return layout;
    }

    // Font-size shrink loop matching neonText.js lines 717-736
    let finalLayout = calculateTextLayout(fontSize);
    while (fontSize > 5) {
        const layout = calculateTextLayout(fontSize);
        const textWidth = Math.max(...layout.maxX) - Math.min(...layout.minX);
        const textHeight = Math.max(...layout.maxY) - Math.min(...layout.minY);
        if (textWidth <= boundingBoxWidth && textHeight <= boundingBoxHeight) {
            finalLayout = layout;
            break;
        }
        fontSize--;
        finalLayout = calculateTextLayout(fontSize);
    }

    // Calculate pixel dimensions (neonText.js lines 818-819)
    const maxWidth = Math.max(...finalLayout.maxX) - Math.min(...finalLayout.minX);
    const totalCalculatedHeight = Math.max(...finalLayout.maxY) - Math.min(...finalLayout.minY);

    // Calculate max characters (neonText.js lines 821-824)
    let maxCharacters = 0;
    lines.forEach((line) => {
        maxCharacters = Math.max(maxCharacters, line.length);
    });

    // Width and height in inches (neonText.js lines 824-828)
    const maxWidthInches = maxCharacters * 2.5;
    const aspectRatio = maxWidth / totalCalculatedHeight;
    const maxHeightInches = maxWidthInches / aspectRatio;

    const finalWidth = Math.round(maxWidthInches) || 17;
    const finalHeight = Math.round(maxHeightInches) || 10;

    return {
        widthInches: isFinite(finalWidth) ? finalWidth : 17,
        heightInches: isFinite(finalHeight) ? finalHeight : 10
    };
}

function regenerateSizeCards(baseWidth, baseHeight) {
    const sizeGrid = document.getElementById('sizeGrid');
    if (!sizeGrid) return;

    const sizeConfigs = [
        { id: 'mini', name: 'Mini', baseLengthIn: 10, baseHeightIn: 17, fontsize: 44 },
        { id: 'small', name: 'Small', baseLengthIn: 13, baseHeightIn: 22, fontsize: 46 },
        { id: 'medium', name: 'Medium', baseLengthIn: 17, baseHeightIn: 28, fontsize: 48 },
        { id: 'large', name: 'Large', baseLengthIn: 22, baseHeightIn: 37, fontsize: 50 },
        { id: 'xl', name: 'XL', baseLengthIn: 29, baseHeightIn: 48, fontsize: 54 },
        { id: 'xxl', name: 'XXL', baseLengthIn: 37, baseHeightIn: 63, fontsize: 56 },
        { id: 'xxxl', name: 'XXXL', baseLengthIn: 48, baseHeightIn: 81, fontsize: 60 },
        { id: '4xl', name: '4XL', baseLengthIn: 63, baseHeightIn: 106, fontsize: 64 }
    ];

    // baseWidth and baseHeight now represent Length and Height (matching neonText.js)
    // baseWidth = Length (horizontal), baseHeight = Height (vertical)
    const lengthRatio = baseWidth / 10;  // base mini length is 10
    const heightRatio = baseHeight / 17;  // base mini height is 17

    // Update minimum dimensions based on mini size (first config, scale=1.0)
    MINIMUM_WIDTH = Math.min(Math.max(1, Math.round(baseWidth)), CONFIG.maximumCustomWidth);
    MINIMUM_HEIGHT = Math.min(Math.max(1, Math.round(baseHeight)), CONFIG.maximumCustomHeight);

    // Update custom input min attributes
    const customWidth = document.getElementById('customWidth');
    const customHeight = document.getElementById('customHeight');
    if (customWidth) {
        customWidth.min = MINIMUM_WIDTH;
        customWidth.max = CONFIG.maximumCustomWidth;
        // Ensure current value is not below new minimum
        if (parseInt(customWidth.value) < MINIMUM_WIDTH) {
            customWidth.value = MINIMUM_WIDTH;
        }
    }
    if (customHeight) {
        customHeight.min = MINIMUM_HEIGHT;
        customHeight.max = CONFIG.maximumCustomHeight;
        // Ensure current value is not below new minimum
        if (parseInt(customHeight.value) < MINIMUM_HEIGHT) {
            customHeight.value = MINIMUM_HEIGHT;
        }
    }

    // Update the custom size note to show current minimum width
    const customSizeNote = document.querySelector('.custom-size-note');
    if (customSizeNote) {
        customSizeNote.innerHTML = `
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5" />
                <path d="M7 3.5V7.5M7 10H7.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            ${getDesignerCopy().customSizeNote(MINIMUM_WIDTH, MINIMUM_HEIGHT)}
        `;
    }

    const currentActiveCard = document.querySelector('.size-card.active');
    const currentActiveSize = currentActiveCard ? currentActiveCard.getAttribute('data-size') : 'mini';

    sizeGrid.innerHTML = '';

    sizeConfigs.forEach((config, index) => {
        const scaledWidth = Math.round(config.baseLengthIn * lengthRatio);
        const scaledHeight = Math.round(config.baseHeightIn * heightRatio);
        const price = calculatePlanPrice(scaledWidth, scaledHeight);

        let totalPrice = price;
        totalPrice += appState.rgbSurcharge;
        totalPrice += appState.cutToPrice;
        appState.extras.forEach(extra => {
            totalPrice += extra.price;
        });

        // Double the total if outdoor location is selected
        if (appState.type === 'outdoor') {
            totalPrice = totalPrice * 2;
        }

        totalPrice = Math.floor(totalPrice) + 0.99;

        let discountedPrice = CONFIG.enableBaseDiscount ?
            totalPrice * (1 - CONFIG.basePromotionPercentage) :
            totalPrice;

        if (appState.discountApplied && appState.activeDiscount) {
            if (appState.activeDiscount.type === 'percentage') {
                discountedPrice *= (1 - appState.activeDiscount.value / 100);
            } else if (appState.activeDiscount.type === 'amount') {
                discountedPrice -= appState.activeDiscount.value;
            }
        }

        discountedPrice = roundCurrency(Math.max(discountedPrice, 0));

        const card = document.createElement('div');
        card.className = `size-card ${config.id === currentActiveSize ? 'active' : ''}`;
        card.setAttribute('data-size', config.id);
        card.setAttribute('data-width', scaledWidth);
        card.setAttribute('data-height', scaledHeight);
        card.setAttribute('data-fontsize', config.fontsize);
        card.setAttribute('data-original', totalPrice.toFixed(2));
        card.setAttribute('data-price', discountedPrice.toFixed(2));

        card.innerHTML = `
            <div class="size-visual">
                <div class="size-rect"></div>
                <svg class="checkmark" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10L8 14L16 6" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <div class="size-info">
                <div class="size-name">${config.name}</div>
                <div class="size-dimensions">${scaledWidth}"x${scaledHeight}"</div>
                <div class="size-pricing">
                    <span class="original-price" style="${!CONFIG.enableBaseDiscount ? 'display: none;' : ''}">$${totalPrice.toFixed(2)}</span>
                    <span class="sale-price">$${discountedPrice.toFixed(2)}</span>
                </div>
            </div>
        `;

        sizeGrid.appendChild(card);

        if (config.id === currentActiveSize) {
            appState.plan.widthIn = scaledWidth;
            appState.plan.heightIn = scaledHeight;
            appState.plan.name = config.name;
            appState.plan.id = config.id;
            appState.fontSizePx = config.fontsize;
            appState.plan.price = calculatePlanPrice(scaledWidth, scaledHeight);
        }
    });

    document.querySelectorAll('.size-card').forEach(card => {
        card.addEventListener('click', () => {
            selectPlan(card);
        });
    });
}


function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}




function attachFontListeners() {
    document.querySelectorAll('.font-card').forEach(card => {
        card.addEventListener('click', () => {
            const fontKey = card.getAttribute('data-font');
            const fontFamily = card.getAttribute('data-family');
            selectFont(fontKey, fontFamily);
        });
    });

    document.querySelectorAll('.font-list-item').forEach(item => {
        item.addEventListener('click', () => {
            const fontKey = item.getAttribute('data-font');
            const fontFamily = item.getAttribute('data-family');
            selectFont(fontKey, fontFamily);

            const content = document.getElementById('fontLibraryContent');
            const trigger = document.getElementById('fontLibraryTrigger');
            if (content) content.classList.remove('open');
            if (trigger) trigger.classList.remove('open');
        });
    });

    const trigger = document.getElementById('fontLibraryTrigger');
    const content = document.getElementById('fontLibraryContent');
    if (trigger && content) {
        trigger.addEventListener('click', () => {
            content.classList.toggle('open');
            trigger.classList.toggle('open');
        });
    }
}

function selectFont(fontKey, fontFamily) {
    appState.fontKey = fontKey;
    appState.fontFamily = fontFamily;

    // Update line height based on the new font family
    appState.lineHeightPx = getLineHeightMultiplier(fontFamily, appState.text);

    document.querySelectorAll('.font-card').forEach(card => card.classList.remove('active'));
    document.querySelectorAll('.font-list-item').forEach(item => item.classList.remove('active'));

    const selectedCard = document.querySelector(`.font-card[data-font="${fontKey}"]`);
    const selectedListItem = document.querySelector(`.font-list-item[data-font="${fontKey}"]`);

    if (selectedCard) selectedCard.classList.add('active');
    if (selectedListItem) selectedListItem.classList.add('active');

    const dimensions = calculateIntelligentDimensions(appState.text);
    appState.plan.widthIn = dimensions.widthInches;
    appState.plan.heightIn = dimensions.heightInches;

    regenerateSizeCards(dimensions.widthInches, dimensions.heightInches);
    recalculatePlanPrice();

    // Ensure the font is loaded before rendering
    ensureFontLoaded(fontFamily).then(() => {
        appState.lineHeightPx = getLineHeightMultiplier(fontFamily, appState.text);
        const loadedDimensions = calculateIntelligentDimensions(appState.text);
        appState.plan.widthIn = loadedDimensions.widthInches;
        appState.plan.heightIn = loadedDimensions.heightInches;
        regenerateSizeCards(loadedDimensions.widthInches, loadedDimensions.heightInches);
        recalculatePlanPrice();
        renderAllPreviews();
        recalculateTotalPrice();
    });
}




function attachColorListeners() {
    document.querySelectorAll('.color-option').forEach(option => {
        option.addEventListener('click', (e) => {
            const colorValue = option.getAttribute('data-color');
            const colorName = option.getAttribute('data-name');

            if (appState.multicolor && appState.selectedCharIndex !== null) {
                appState.characterColors[appState.selectedCharIndex] = colorValue;
                renderAllPreviews();
            } else {
                document.querySelectorAll('.color-option').forEach(opt => opt.classList.remove('active'));
                option.classList.add('active');
                selectColor(colorValue, colorName);
            }
        });
    });

    const customBtn = document.getElementById('customColorBtn');
    const customPicker = document.getElementById('customColorPicker');

    if (customBtn && customPicker) {
        customBtn.addEventListener('click', () => customPicker.click());

        customPicker.addEventListener('input', (e) => {
            const colorValue = e.target.value;

            if (appState.multicolor && appState.selectedCharIndex !== null) {
                appState.characterColors[appState.selectedCharIndex] = colorValue;
            } else {
                selectColor(colorValue, 'Custom');
            }

            renderAllPreviews();
        });
    }

    const multiToggle = document.getElementById('multicolorToggle');
    const multiHelp = document.getElementById('multicolorHelp');

    function setCanvasPointerEvents(enabled) {
        document.querySelectorAll('canvas').forEach(canvas => {
            canvas.style.pointerEvents = enabled ? '' : 'none';
        });
    }

    // Canvases non-interactive by default (multicolor is off)
    setCanvasPointerEvents(false);

    if (multiToggle) {
        multiToggle.addEventListener('change', () => {
            if (multiToggle.checked && appState.rgbMode) {
                stopRgbMode();
                const rgbOption = document.querySelector('.color-option[data-color="rgb"]');
                if (rgbOption) {
                    rgbOption.classList.remove('active');
                }
                recalculateTotalPrice();
            }

            appState.multicolor = multiToggle.checked;

            if (!multiToggle.checked) {
                appState.characterColors = {};
                appState.selectedCharIndex = null;
                hideColorPopup();
            }

            if (multiHelp) {
                multiHelp.classList.toggle('hidden', !multiToggle.checked);
            }

            setCanvasPointerEvents(multiToggle.checked);
            renderAllPreviews();
        });
    }
}

function selectColor(colorValue, colorName) {
    if (colorName === 'RGB Color Changing' || colorValue === 'rgb') {
        startRgbMode();
    } else {
        if (appState.rgbMode) {
            stopRgbMode();
        }

        appState.colorValue = colorValue;
        appState.colorName = colorName;
        appState.rgbSurcharge = 0;
    }

    renderAllPreviews();
    recalculateTotalPrice();
}

function startRgbMode() {
    if (appState.multicolor) {
        appState.multicolor = false;
        appState.characterColors = {};
        appState.selectedCharIndex = null;
        hideColorPopup();

        const multiToggle = document.getElementById('multicolorToggle');
        if (multiToggle) {
            multiToggle.checked = false;
        }

        const multiHelp = document.getElementById('multicolorHelp');
        if (multiHelp) {
            multiHelp.classList.add('hidden');
        }
    }

    appState.rgbMode = true;
    appState.colorName = 'RGB Color Changing';
    appState.rgbSurcharge = CONFIG.rgbSurcharge;

    let colorIndex = 0;

    appState.rgbAnimationTimer = setInterval(() => {
        appState.colorValue = CONFIG.rgbColorSequence[colorIndex];
        colorIndex = (colorIndex + 1) % CONFIG.rgbColorSequence.length;
        renderAllPreviews();
    }, CONFIG.rgbCycleSpeed);

    recalculateTotalPrice();
}

function stopRgbMode() {
    appState.rgbMode = false;
    appState.rgbSurcharge = 0;

    if (appState.rgbAnimationTimer) {
        clearInterval(appState.rgbAnimationTimer);
        appState.rgbAnimationTimer = null;
    }
}




let customSizingAspectRatio = 23 / 10;

function updateAspectRatio() {
    if (appState.plan.widthIn && appState.plan.heightIn) {
        customSizingAspectRatio = appState.plan.widthIn / appState.plan.heightIn;
    }
}

function isCustomSizeMode() {
    return document.querySelector('.size-mode-btn.active')?.dataset.mode === 'custom';
}

function setCustomSizeError(message, invalidInputs = []) {
    const error = document.getElementById('customSizeError');
    const text = document.getElementById('customSizeErrorText');
    const inputs = [document.getElementById('customWidth'), document.getElementById('customHeight')].filter(Boolean);

    inputs.forEach(input => {
        const isInvalid = invalidInputs.includes(input);
        input.toggleAttribute('aria-invalid', isInvalid);
        if (isInvalid) input.setAttribute('aria-describedby', 'customSizeError');
        else input.removeAttribute('aria-describedby');
    });

    if (error && text) {
        text.textContent = message;
        error.classList.remove('hidden');
    }
}

function clearCustomSizeError() {
    document.getElementById('customSizeError')?.classList.add('hidden');
    [document.getElementById('customWidth'), document.getElementById('customHeight')]
        .filter(Boolean)
        .forEach(input => {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
        });
}

function validateCustomSize({ focus = false } = {}) {
    if (!isCustomSizeMode()) return true;

    const widthInput = document.getElementById('customWidth');
    const heightInput = document.getElementById('customHeight');
    if (!widthInput || !heightInput) return false;

    const width = Number(widthInput.value);
    const height = Number(heightInput.value);
    const widthValid = Number.isFinite(width) && width >= MINIMUM_WIDTH && width <= CONFIG.maximumCustomWidth;
    const heightValid = Number.isFinite(height) && height >= MINIMUM_HEIGHT && height <= CONFIG.maximumCustomHeight;

    if (!widthValid || !heightValid) {
        const invalid = [];
        if (!widthValid) invalid.push(widthInput);
        if (!heightValid) invalid.push(heightInput);
        setCustomSizeError(getDesignerCopy().customSizeRange(MINIMUM_WIDTH, MINIMUM_HEIGHT), invalid);
        if (focus) invalid[0]?.focus({ preventScroll: true });
        return false;
    }

    clearCustomSizeError();
    return true;
}

function commitCustomSize(width, height) {
    appState.plan.widthIn = width;
    appState.plan.heightIn = height;
    appState.plan.name = 'Custom';
    appState.plan.id = 'custom';
    recalculatePlanPrice();
    renderAllPreviews();
    recalculateTotalPrice();
}

function updateCustomSizeFromInput(source) {
    const widthInput = document.getElementById('customWidth');
    const heightInput = document.getElementById('customHeight');
    if (!widthInput || !heightInput) return;

    const sourceInput = source === 'width' ? widthInput : heightInput;
    const rawValue = Number(sourceInput.value);
    const minimum = source === 'width' ? MINIMUM_WIDTH : MINIMUM_HEIGHT;
    const maximum = source === 'width' ? CONFIG.maximumCustomWidth : CONFIG.maximumCustomHeight;

    if (!Number.isFinite(rawValue) || rawValue < minimum || rawValue > maximum) {
        setCustomSizeError(getDesignerCopy().customSizeRange(MINIMUM_WIDTH, MINIMUM_HEIGHT), [sourceInput]);
        return;
    }

    const width = source === 'width' ? Math.round(rawValue) : Math.round(rawValue * customSizingAspectRatio);
    const height = source === 'height' ? Math.round(rawValue) : Math.round(rawValue / customSizingAspectRatio);

    if (width < MINIMUM_WIDTH || width > CONFIG.maximumCustomWidth) {
        setCustomSizeError(getDesignerCopy().customSizeAspect(width, CONFIG.maximumCustomWidth), [widthInput]);
        return;
    }
    if (height < MINIMUM_HEIGHT || height > CONFIG.maximumCustomHeight) {
        setCustomSizeError(getDesignerCopy().customSizeAspect(height, CONFIG.maximumCustomHeight), [heightInput]);
        return;
    }

    widthInput.value = width;
    heightInput.value = height;
    clearCustomSizeError();
    commitCustomSize(width, height);
}

function attachPlanListeners() {
    document.querySelectorAll('.size-mode-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.size-mode-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            const mode = btn.getAttribute('data-mode');
            toggleSizeMode(mode);
        });
    });

    const customWidth = document.getElementById('customWidth');
    const customHeight = document.getElementById('customHeight');
    // Initial min values will be set by regenerateSizeCards
    // Ensure current values are valid
    if (customWidth) {
        customWidth.min = MINIMUM_WIDTH;
        customWidth.max = CONFIG.maximumCustomWidth;
    }
    if (customHeight) {
        customHeight.min = MINIMUM_HEIGHT;
        customHeight.max = CONFIG.maximumCustomHeight;
    }

    if (customWidth) {
        customWidth.addEventListener('input', debounce(() => updateCustomSizeFromInput('width'), 150));
    }

    if (customHeight) {
        customHeight.addEventListener('input', debounce(() => updateCustomSizeFromInput('height'), 150));
    }

    document.addEventListener('click', (e) => {
        const sizeCard = e.target.closest('.size-card');
        if (sizeCard) {
            selectPlan(sizeCard);
        }
    });
}

function toggleSizeMode(mode) {
    const sizeGrid = document.getElementById('sizeGrid');
    const customInputs = document.getElementById('customSizeInputs');
    const title = document.getElementById('sizeModeTitle');

    if (mode === 'custom') {
        sizeGrid?.classList.add('hidden');
        customInputs?.classList.remove('hidden');
        if (title) title.textContent = getDesignerCopy().enterCustomSize;
        validateCustomSize();
    } else {
        sizeGrid?.classList.remove('hidden');
        customInputs?.classList.add('hidden');
        if (title) title.textContent = getDesignerCopy().selectSize;
        clearCustomSizeError();
    }
}

function selectPlan(cardElement) {
    document.querySelectorAll('.size-card').forEach(c => c.classList.remove('active'));
    cardElement.classList.add('active');

    appState.plan.id = cardElement.getAttribute('data-size');
    appState.plan.name = cardElement.querySelector('.size-name')?.textContent || 'Medium';
    appState.plan.widthIn = parseInt(cardElement.getAttribute('data-width')) || 38;
    appState.plan.heightIn = parseInt(cardElement.getAttribute('data-height')) || 17;
    appState.fontSizePx = parseFloat(cardElement.getAttribute('data-fontsize')) || 38;

    appState.plan.price = calculatePlanPrice(appState.plan.widthIn, appState.plan.heightIn);

    if (typeof updateAspectRatio === 'function') {
        updateAspectRatio();
    }

    // Update custom size inputs to match selected card
    const customWidth = document.getElementById('customWidth');
    const customHeight = document.getElementById('customHeight');
    if (customWidth) customWidth.value = appState.plan.widthIn;
    if (customHeight) customHeight.value = appState.plan.heightIn;

    renderAllPreviews();
    recalculateTotalPrice();
}

function generatePlansFromMeasurements() {
    return;
}

function generateInitialPlans() {
    return;
}

function updatePlanCardsInUI() {
    return;
}




function calculatePlanPrice(widthIn, heightIn) {
    const area = widthIn * heightIn;
    const isRGB = appState.rgbMode || appState.rgbSurcharge > 0;

    const productCostPerInch = isRGB ? CONFIG.productCostPerInchRGB : CONFIG.productCostPerInchStandard;
    const shippingCostPerInch = CONFIG.shippingCostPerInch;
    const usdToCadMultiplier = CONFIG.usdToCadMultiplier;

    const shippingCost = area * shippingCostPerInch;
    const productCost = area * productCostPerInch;
    const localShippingCostUSD = CONFIG.localShippingCostUSD;

    const profitUSD = Math.max(
        CONFIG.minProfitPercentage * (productCost + shippingCost + localShippingCostUSD),
        CONFIG.minProfitUSD
    );
    const totalCostUSD = productCost + shippingCost + profitUSD + localShippingCostUSD;
    let totalCostCAD = totalCostUSD * usdToCadMultiplier;

    if (CONFIG.premiumFontsDouble.includes(appState.fontKey.toLowerCase())) {
        totalCostCAD *= 2;
    }

    const finalPrice = Math.max(totalCostCAD, CONFIG.basePrice);
    return finalPrice;
}

function recalculatePlanPrice() {
    appState.plan.price = calculatePlanPrice(appState.plan.widthIn, appState.plan.heightIn);
}

function recalculateTotalPrice() {
    let total = appState.plan.price;

    appState.extras.forEach(extra => {
        total += extra.price;
    });

    total += appState.rgbSurcharge;
    total += appState.cutToPrice;

    // Double the total if outdoor location is selected
    if (appState.type === 'outdoor') {
        total = total * 2;
    }

    total = Math.floor(total) + 0.99;
    appState.totalPrice = total;

    let discounted = CONFIG.enableBaseDiscount ?
        total * (1 - CONFIG.basePromotionPercentage) :
        total;

    if (appState.discountApplied && appState.activeDiscount) {
        if (appState.activeDiscount.type === 'percentage') {
            discounted *= (1 - appState.activeDiscount.value / 100);
        } else if (appState.activeDiscount.type === 'amount') {
            discounted -= appState.activeDiscount.value;
        }
    }

    discounted = roundCurrency(Math.max(discounted, 0));
    appState.discountPrice = discounted;

    if (!appState.activeDiscount) {
        appState.originalDiscountPrice = discounted;
    }

    updatePricingUI();
    updateSizeCardPrices();
}

function updatePricingUI() {
    const basePercentageSpan = document.querySelector('.base-percentage');
    const discountBadge = document.querySelector('.discount-badge');
    const originalElem = document.querySelector('.original-total');
    const finalElem = document.querySelector('.final-price');

    if (originalElem) {
        if (!CONFIG.enableBaseDiscount) {
            originalElem.style.display = 'none';
        } else {
            originalElem.textContent = `$${appState.totalPrice.toFixed(2)}`;
        }
    }
    if (discountBadge) {
        if (!CONFIG.enableBaseDiscount) {
            discountBadge.style.display = 'none';
        } else {
            basePercentageSpan.textContent = `${(CONFIG.basePromotionPercentage * 100).toFixed(0)}`;
        }
    }
    if (finalElem) {
        finalElem.textContent = `$${appState.discountPrice.toFixed(2)}`;
    }

    // Update all .quick-pricing blocks across all steps
    document.querySelectorAll('.quick-pricing').forEach(block => {
        const quickOriginal = block.querySelector('.original-price');
        const quickSale = block.querySelector('.sale-price');
        const quickNote = block.querySelector('.price-note');

        if (quickOriginal && quickSale && quickNote) {
            if (CONFIG.enableBaseDiscount) {
                quickOriginal.style.display = '';
                quickOriginal.textContent = `$${appState.totalPrice.toFixed(2)}`;
                quickSale.textContent = `$${appState.discountPrice.toFixed(2)}`;
                const pct = (CONFIG.basePromotionPercentage * 100).toFixed(0);
                quickNote.textContent = getDesignerCopy().limitedTime(pct);
            } else {
                quickOriginal.style.display = 'none';
                quickSale.style.display = 'none';
                quickNote.style.display = 'none';
            }
        }
    });

    document.querySelectorAll('.btn-next, .btn-final').forEach(btn => {
        const originalText = btn.classList.contains('btn-final')
            ? getDesignerCopy().previewAndBuy
            : getDesignerCopy().next;
        if (!btn.getAttribute('data-original-text')) {
            btn.setAttribute('data-original-text', originalText);
        }

        const priceText = `$${appState.discountPrice.toFixed(2)}`;
        btn.innerHTML = btn.innerHTML.replace(/\s*-\s*\$[\d,.]+/, '');

        const svgIcon = btn.querySelector('svg');
        if (svgIcon) {
            btn.innerHTML = `<span class="btn-label">${originalText}</span><span class="btn-price">${priceText}</span>` + svgIcon.outerHTML;
        } else {
            btn.innerHTML = `<span class="btn-label">${originalText}</span><span class="btn-price">${priceText}</span>`;
        }
    });
}

function updateSizeCardPrices() {
    document.querySelectorAll('.size-card').forEach(card => {
        const widthIn = parseInt(card.getAttribute('data-width')) || 38;
        const heightIn = parseInt(card.getAttribute('data-height')) || 17;

        // Calculate base price (only width, height, and font) - no extras
        let basePrice = calculatePlanPrice(widthIn, heightIn);

        let totalPrice = basePrice;
        // Removed extra charges: RGB surcharge, shape charges, backboard charges, hanging options, outdoor multiplier

        totalPrice = Math.floor(totalPrice) + 0.99;

        let discountedPrice = CONFIG.enableBaseDiscount ?
            totalPrice * (1 - CONFIG.basePromotionPercentage) :
            totalPrice;

        if (appState.discountApplied && appState.activeDiscount) {
            if (appState.activeDiscount.type === 'percentage') {
                discountedPrice *= (1 - appState.activeDiscount.value / 100);
            } else if (appState.activeDiscount.type === 'amount') {
                discountedPrice -= appState.activeDiscount.value;
            }
        }

        discountedPrice = roundCurrency(Math.max(discountedPrice, 0));

        const originalPriceElem = card.querySelector('.original-price');
        const salePriceElem = card.querySelector('.sale-price');

        if (originalPriceElem) {
            if (!CONFIG.enableBaseDiscount) {
                originalPriceElem.style.display = 'none';
            } else {
                originalPriceElem.textContent = `$${totalPrice.toFixed(2)}`;
            }
        }

        if (salePriceElem) {
            salePriceElem.textContent = `$${discountedPrice.toFixed(2)}`;
        }

        card.setAttribute('data-original', totalPrice.toFixed(2));
        card.setAttribute('data-price', discountedPrice.toFixed(2));
    });
    attachPlanListeners();
}




function attachLocationListeners() {
    document.querySelectorAll('input[name="location"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
            const parent = e.target.closest('.radio-option');
            document.querySelectorAll('.radio-group .radio-option').forEach(opt =>
                opt.classList.remove('active')
            );
            parent?.classList.add('active');

            appState.type = e.target.value;

            recalculateTotalPrice();
        });
    });
}

function attachShapeListeners() {
    document.querySelectorAll('.shape-card').forEach(card => {
        card.addEventListener('click', () => {
            document.querySelectorAll('.shape-card').forEach(c => c.classList.remove('active'));
            card.classList.add('active');

            appState.cutTo = card.getAttribute('data-shape');
            appState.cutToPrice = parseFloat(card.getAttribute('data-price')) || 0;

            recalculateTotalPrice();
        });
    });

    document.querySelectorAll('input[name="backboard"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
            document.querySelectorAll('.backboard-color-option').forEach(opt => opt.classList.remove('active'));

            const parent = e.target.closest('.backboard-color-option');
            if (parent) parent.classList.add('active');

            appState.backboard = e.target.value;
        });
    });
}




function attachExtrasListeners() {

    document.querySelectorAll('input[name="hanging"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
            const parent = e.target.closest('.radio-option');
            document.querySelectorAll('#step4 .radio-group .radio-option').forEach(opt =>
                opt.classList.remove('active')
            );
            parent?.classList.add('active');

            const hangingType = e.target.value;
            const hangingPrice = (hangingType === 'wall' || hangingType === 'sign') ? 15 : 0;


            appState.extras = appState.extras.filter(ex => ex.id !== 'hanging');


            if (hangingPrice > 0) {
                appState.extras.push({
                    id: 'hanging',
                    description: `${hangingType} hanging`,
                    price: hangingPrice
                });
            }

            recalculateTotalPrice();
        });
    });


    const waterproofCheck = document.getElementById('waterProof');
    if (waterproofCheck) {
        waterproofCheck.addEventListener('change', (e) => {
            const parent = e.target.closest('.checkbox-option');

            appState.extras = appState.extras.filter(ex => ex.id !== 'waterproof');

            if (e.target.checked) {
                appState.extras.push({
                    id: 'waterproof',
                    description: 'Waterproof protection',
                    price: 30
                });
                if (parent) parent.classList.add('active');
            } else {
                if (parent) parent.classList.remove('active');
            }

            recalculateTotalPrice();
        });
    }


    const remoteDimmerCheck = document.getElementById('remoteDimmer');
    if (remoteDimmerCheck) {
        remoteDimmerCheck.addEventListener('change', (e) => {
            const parent = e.target.closest('.checkbox-option');


            appState.extras = appState.extras.filter(ex => ex.id !== 'remote');

            if (e.target.checked) {
                appState.extras.push({
                    id: 'remote',
                    description: 'Remote and Dimmer',
                    price: 0
                });
                if (parent) parent.classList.add('active');
            } else {
                if (parent) parent.classList.remove('active');
            }
        });
    }


    document.querySelectorAll('input[name="power"]').forEach(radio => {
        radio.addEventListener('change', (e) => {

            document.querySelectorAll('.radio-pill').forEach(pill => pill.classList.remove('active'));


            const parent = e.target.closest('.radio-pill');
            if (parent) parent.classList.add('active');


            appState.powerAdapter = e.target.value;
        });
    });
}




function attachDiscountListeners() {
    const applyBtn = document.querySelector('.apply-btn');
    const discountInput = document.getElementById('discountCode');

    if (applyBtn && discountInput) {
        applyBtn.addEventListener('click', () => {
            const code = discountInput.value.trim();

            if (!code) {
                return;
            }

            if (appState.discountApplied) {

                removeDiscount();
                applyBtn.textContent = getDesignerCopy().apply;
                discountInput.value = '';
            } else {

                validateAndApplyDiscount(code);
            }
        });

        // Allow pressing Enter to apply discount
        discountInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                applyBtn.click();
            }
        });
    }
}

async function validateAndApplyDiscount(code) {
    const applyBtn = document.querySelector('.apply-btn');
    const copy = getDesignerCopy();

    // Disable button during validation
    if (applyBtn) {
        applyBtn.disabled = true;
        applyBtn.textContent = copy.validating;
    }

    try {
        const upperCode = code.toUpperCase();
        const idempotencyKey = 'discount-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const response = await fetch(CONFIG.couponApiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': 'ghhgkkf7fjfhhfkfklflllfl',
                'X-Idempotency-Key': idempotencyKey
            },
            body: JSON.stringify({ discount_code: code })
        });

        const data = await response.json().catch(() => ({}));
        let discount = null;
        if (data.discount_percentage) {
            discount = { type: 'percentage', value: Number(data.discount_percentage) };
        } else if (data.discount_amount) {
            discount = { type: 'amount', value: Number(data.discount_amount) };
        }

        if (response.ok && data.success && discount && Number.isFinite(discount.value) && discount.value > 0) {
            applyDiscount(discount, upperCode);
            if (applyBtn) applyBtn.textContent = copy.remove;
            showDiscountMessage(copy.couponApplied(upperCode), 'success');
        } else if ([400, 404, 422].includes(response.status) || data.success === false) {
            showDiscountMessage(copy.couponInvalid, 'error');
        } else {
            showDiscountMessage(copy.couponNetwork, 'error');
        }
    } catch (error) {
        console.warn('[discount] Validation request failed.');
        showDiscountMessage(copy.couponNetwork, 'error');
    } finally {
        if (applyBtn && !appState.discountApplied) {
            applyBtn.disabled = false;
            applyBtn.textContent = copy.apply;
        } else if (applyBtn) {
            applyBtn.disabled = false;
        }
    }
}

function applyDiscount(discount, code) {
    if (!discount || !Number.isFinite(discount.value) || discount.value <= 0) return;
    appState.discountApplied = true;
    appState.activeDiscount = discount;
    appState.discountCode = code;
    recalculateTotalPrice();
}

function removeDiscount() {
    appState.discountApplied = false;
    appState.activeDiscount = null;
    appState.discountCode = null;

    // Hide any discount messages
    const messageEl = document.querySelector('.discount-message');
    if (messageEl) {
        messageEl.remove();
    }

    recalculateTotalPrice();
}

function showDiscountMessage(message, type = 'info') {
    // Remove existing message
    const existingMessage = document.querySelector('.discount-message');
    if (existingMessage) {
        existingMessage.remove();
    }

    const discountSection = document.querySelector('.discount-code-section');
    if (!discountSection) return;

    const messageEl = document.createElement('div');
    messageEl.className = `discount-message discount-message-${type}`;
    messageEl.textContent = message;
    messageEl.setAttribute('role', type === 'error' ? 'alert' : 'status');
    messageEl.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');

    discountSection.insertAdjacentElement('afterend', messageEl);
    setTimeout(() => {
        messageEl.remove();
    }, 5000);
}




function attachCheckoutListener() {
    const checkoutBtn = document.querySelector('.btn-final');

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
            showPreviewModal();
        });
    }
}

let previewModalOpening = false;
let previewModalTrigger = null;
let previewModalBodyOverflow = '';

function setPreviewModalBusy(isBusy) {
    const triggers = document.querySelectorAll('.btn-final, .preview-eye-btn, #mobileNextBtn');
    triggers.forEach(trigger => {
        trigger.disabled = isBusy;
        trigger.setAttribute('aria-busy', String(isBusy));
    });

    const mobileButton = document.getElementById('mobileNextBtn');
    if (mobileButton && isBusy) {
        mobileButton.textContent = getSignTextCopy().preparing;
    } else if (mobileButton) {
        updateMobileFooter();
    }
}

async function showPreviewModal() {
    if (!validateSignText({ focus: true })) return;
    if (!validateCustomSize({ focus: true })) return;

    const existingOverlay = document.getElementById('previewModalOverlay');
    if (existingOverlay) {
        existingOverlay.querySelector('.modal-close-btn')?.focus();
        return;
    }
    if (previewModalOpening) return;

    previewModalOpening = true;
    previewModalTrigger = document.activeElement;
    setPreviewModalBusy(true);

    try {
    // Ensure all canvases have current content rendered
    renderAllPreviews();

    // Wait for the canvas to finish rendering including filters
    await new Promise(resolve => requestAnimationFrame(() =>
        requestAnimationFrame(() =>
            setTimeout(resolve, 100)
        )
    ));

    const previewSVG = await capturePreviewSnapshot();

    if (document.getElementById('previewModalOverlay')) return;
    const overlay = document.createElement('div');
    overlay.className = 'preview-modal-overlay';
    overlay.id = 'previewModalOverlay';


    const modal = document.createElement('div');
    modal.className = 'preview-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'previewModalTitle');


    const featuresSummary = generateFeaturesSummary();
    const pricingSubtotal = roundCurrency(appState.totalPrice);
    const priceAfterBaseDiscount = CONFIG.enableBaseDiscount
        ? roundCurrency(pricingSubtotal * (1 - CONFIG.basePromotionPercentage))
        : pricingSubtotal;
    const baseDiscountAmount = roundCurrency(pricingSubtotal - priceAfterBaseDiscount);
    const couponDiscountAmount = roundCurrency(Math.max(priceAfterBaseDiscount - appState.discountPrice, 0));
    const copy = getDesignerCopy();

    modal.innerHTML = `
        <div class="modal-header">
            <div class="modal-heading">
                <span class="modal-kicker">${copy.orderKicker}</span>
                <h2 class="modal-title" id="previewModalTitle">${copy.orderTitle}</h2>
                <p class="modal-intro">${copy.orderIntro}</p>
            </div>
            <button class="modal-close-btn" type="button" onclick="closePreviewModal()" aria-label="${copy.closeOrder}">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <div class="preview-section">
                <div class="preview-snapshot-svg">${previewSVG}</div>
            </div>

            <div class="features-section">
                <h3 class="section-title">${copy.selectedFeatures}</h3>
                <div class="features-grid">
                    ${featuresSummary}
                </div>
            </div>

            <div class="price-breakdown">
                <div class="price-row subtotal">
                    <span class="price-label">${copy.configuredSubtotal}</span>
                    <span class="price-value">$${pricingSubtotal.toFixed(2)}</span>
                </div>
                ${CONFIG.enableBaseDiscount ? `
                <div class="price-row discount">
                    <span class="price-label">${copy.baseDiscount} (${(CONFIG.basePromotionPercentage * 100)}%)</span>
                    <span class="price-value discount-value">-$${baseDiscountAmount.toFixed(2)}</span>
                </div>
                ` : ''}
                ${appState.discountApplied && appState.activeDiscount ? `
                <div class="price-row discount">
                    <span class="price-label">${copy.coupon} (${escapeSummaryValue(appState.discountCode)})
                        ${appState.activeDiscount.type === 'percentage' ?
                `${appState.activeDiscount.value}%` :
                `$${appState.activeDiscount.value}`} ${copy.off}
                    </span>
                    <span class="price-value discount-value">-$${couponDiscountAmount.toFixed(2)}</span>
                </div>
                ` : ''}
                <div class="price-row total">
                    <span class="price-label">${copy.total}</span>
                    <span class="price-value">$${appState.discountPrice.toFixed(2)}</span>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="modal-btn modal-btn-secondary" type="button" onclick="closePreviewModal()">
                ${copy.continueEditing}
            </button>
            <button class="modal-btn modal-btn-primary" type="button" onclick="proceedToCheckout()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M6 2L3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V6L14 2H6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3 6H17M13 10C13 11.0609 12.5786 12.0783 11.8284 12.8284C11.0783 13.5786 10.0609 14 9 14C7.93913 14 6.92172 13.5786 6.17157 12.8284C5.42143 12.0783 5 11.0609 5 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                ${copy.buyNow}
            </button>
        </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);


    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            closePreviewModal();
        }
    });

    overlay.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            closePreviewModal();
            return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...overlay.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    previewModalBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';


    window.closePreviewModal = closePreviewModal;
    window.proceedToCheckout = proceedToCheckout;
    requestAnimationFrame(() => overlay.querySelector('.modal-close-btn')?.focus());
    } finally {
        previewModalOpening = false;
        setPreviewModalBusy(false);
    }
}

function closePreviewModal() {
    document.querySelectorAll('#previewModalOverlay').forEach(overlay => overlay.remove());
    document.body.style.overflow = previewModalBodyOverflow;
    if (previewModalTrigger && typeof previewModalTrigger.focus === 'function') {
        previewModalTrigger.focus({ preventScroll: true });
    }
    previewModalTrigger = null;
}


// Throttle mechanism to prevent excessive render calls
let renderPending = false;
let renderTimeout = null;

// Render all previews across all steps
function renderAllPreviews() {
    // Cancel any pending render
    if (renderTimeout) {
        clearTimeout(renderTimeout);
    }

    // If a render is already scheduled, don't schedule another
    if (renderPending) {
        return;
    }

    renderPending = true;

    // Use requestAnimationFrame for optimal rendering timing
    requestAnimationFrame(() => {
        Object.keys(canvasInstances).forEach(canvasId => {
            const canvas = canvasInstances[canvasId];
            if (canvas) {
                renderCanvasPreview(canvas);
            }
        });
        renderPending = false;
    });
}



function createNeonShadow(color) {
    return new fabric.Shadow({
        color: color,
        blur: 40,
        offsetX: 0,
        offsetY: 0
    });
}

// Step navigation
function attachStepNavigationListeners() {
    // Step tabs
    document.querySelectorAll('.step-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            const stepNum = parseInt(tab.getAttribute('data-step'));
            goToStep(stepNum);
        });
    });

    // Mobile toggle buttons
    document.querySelectorAll('.mobile-toggle-btn').forEach((btn, idx) => {
        btn.addEventListener('click', () => {
            const stepContainer = btn.closest('.step-container');
            if (stepContainer) {
                stepContainer.classList.toggle('mobile-preview-open');
            }
        });
    });
}

function goToStep(stepNum) {
    // Hide all steps
    document.querySelectorAll('.step-container').forEach(container => {
        container.classList.remove('active');
    });

    // Show target step
    const targetStep = document.getElementById(`step${stepNum}`);
    if (targetStep) {
        targetStep.classList.add('active');
    }

    // Update step tabs
    document.querySelectorAll('.step-tab').forEach(tab => {
        const tabStep = parseInt(tab.getAttribute('data-step'));
        tab.classList.remove('active', 'completed');

        if (tabStep === stepNum) {
            tab.classList.add('active');
        } else if (tabStep < stepNum) {
            tab.classList.add('completed');
        }
    });

    appState.currentStep = stepNum;
}

// Preview controls
function attachPreviewControlListeners() {
    // Neon toggle switches
    document.querySelectorAll('[id^="neonToggle"]').forEach(toggle => {
        toggle.addEventListener('change', (e) => {
            appState.neonGlowEnabled = e.target.checked;
            toggle.nextElementSibling.textContent = e.target.checked ? 'ON' : 'OFF';
            renderAllPreviews();
        });
    });

    // Theme mode toggles
    document.querySelectorAll('.mode-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const mode = btn.getAttribute('data-mode');
            const group = btn.closest('.theme-mode-toggle');

            group.querySelectorAll('.mode-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            appState.themeMode = mode;

            // Update background images
            document.querySelectorAll('.background-image-wrapper').forEach(wrapper => {
                if (mode === 'dark') {
                    wrapper.style.opacity = '1';
                } else {
                    wrapper.style.opacity = '0.3';
                }
            });
        });
    });

    // Save preview buttons
    document.querySelectorAll('[id^="saveBtn"]').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const stepNum = btn.id.replace('saveBtn', '') || '1';
            const rect = btn.getBoundingClientRect();

            // Show export format menu
            showExportMenu(parseInt(stepNum), rect);
        });
    });

}

// Generate SVG string for preview (helper function)
async function generatePreviewSVG(canvas) {
    if (!canvas) return '';

    const objects = canvas.getObjects();
    if (objects.length === 0) {
        return '';
    }

    // Calculate bounding box of all objects
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

    objects.forEach(obj => {
        const bounds = obj.getBoundingRect();
        minX = Math.min(minX, bounds.left);
        minY = Math.min(minY, bounds.top);
        maxX = Math.max(maxX, bounds.left + bounds.width);
        maxY = Math.max(maxY, bounds.top + bounds.height);
    });

    // Add padding
    const padding = 80;
    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(canvas.width, maxX + padding);
    maxY = Math.min(canvas.height, maxY + padding);

    const width = maxX - minX;
    const height = maxY - minY;

    // Get SVG string from Fabric.js
    let svgString = canvas.toSVG({
        viewBox: {
            x: minX,
            y: minY,
            width: width,
            height: height
        },
        width: width,
        height: height,
        suppressPreamble: false
    });

    // Add background color based on current theme
    const isDarkMode = document.querySelector('.mode-btn.active[data-mode="dark"]') !== null;
    const bgColor = isDarkMode ? '#000000' : '#ffffff';

    // Embed font in SVG
    svgString = await embedFontInSVG(svgString, appState.fontFamily);

    return svgString;
}

// Capture preview snapshot
async function capturePreviewSnapshot() {
    const canvas = canvasInstances['neonCanvas4'] || canvasInstances['neonCanvas'];
    if (!canvas) return '';

    // Force another render to ensure all filters are applied
    canvas.renderAll();

    // Wait for filters to be fully applied
    await new Promise(resolve => requestAnimationFrame(() =>
        requestAnimationFrame(() =>
            setTimeout(resolve, 50)
        )
    ));

    // Generate and return SVG string directly for inline embedding (with embedded font)
    const svgString = await generatePreviewSVG(canvas);
    return svgString || '';
}

function escapeSummaryValue(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

// Generate features summary for modal
function generateFeaturesSummary() {
    const features = [];

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Text:</span>
            <span class="feature-value">${escapeSummaryValue(appState.text).replace(/\n/g, '<br>')}</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Font:</span>
            <span class="feature-value">${escapeSummaryValue(appState.fontFamily)}</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Color:</span>
            <span class="feature-value">${escapeSummaryValue(appState.colorName)}</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Size:</span>
            <span class="feature-value">${appState.plan.name} (${appState.plan.widthIn}" × ${appState.plan.heightIn}")</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Location:</span>
            <span class="feature-value">${appState.type.charAt(0).toUpperCase() + appState.type.slice(1)}</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Shape:</span>
            <span class="feature-value">${formatShapeName(appState.cutTo)}</span>
        </div>
    `);

    features.push(`
        <div class="feature-item">
            <span class="feature-label">Backboard:</span>
            <span class="feature-value">${formatBackboardName(appState.backboard)}</span>
        </div>
    `);

    return features.join('');
}

function formatShapeName(shape) {
    const names = {
        'cut-to-shape': 'Cut to Shape',
        'cut-to-letter': 'Cut to Letter',
        'cut-rectangle': 'Cut Rectangle',
        'cut-to-cirlce': 'Cut to Circle'
    };
    return names[shape] || shape;
}

function formatBackboardName(backboard) {
    const names = {
        'clear': 'Standard Clear Acrylic',
        'glossy-white': 'Glossy White Acrylic',
        'glossy-black': 'Glossy Black Acrylic',
        'silver': 'Silver Acrylic',
        'gold': 'Gold Acrylic'
    };
    return names[backboard] || backboard;
}

function generateFeaturesSummary() {
    const copy = getDesignerCopy();
    const features = [
        {
            label: copy.featureLabels.text,
            value: appState.text || (isFrenchDesigner() ? 'Votre texte' : 'Your Text')
        },
        {
            label: copy.featureLabels.font,
            value: formatFontName(appState.fontKey)
        },
        {
            label: copy.featureLabels.color,
            value: copy.colors[appState.colorName] || appState.colorName
        },
        {
            label: copy.featureLabels.size,
            value: `${appState.plan.name} (${appState.plan.widthIn}" × ${appState.plan.heightIn}")`
        },
        {
            label: copy.featureLabels.location,
            value: copy.locations[appState.type] || appState.type
        },
        {
            label: copy.featureLabels.shape,
            value: formatShapeName(appState.cutTo)
        },
        {
            label: copy.featureLabels.backboard,
            value: formatBackboardName(appState.backboard)
        },
        {
            label: copy.featureLabels.power,
            value: formatPowerAdapter(appState.powerAdapter || 'canada')
        }
    ];


    if (appState.extras.length > 0) {
        appState.extras.forEach(extra => {
            features.push({
                label: copy.featureLabels.extra,
                value: copy.extras[extra.id] || extra.description
            });
        });
    }

    return features.map(feature => `
        <div class="feature-item">
            <div class="feature-label">${escapeSummaryValue(feature.label)}</div>
            <div class="feature-value">${escapeSummaryValue(feature.value).replace(/\n/g, '<br>')}</div>
        </div>
    `).join('');
}

function formatFontName(fontKey) {
    return fontKey
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function formatShapeName(shape) {
    return getDesignerCopy().shapes[shape] || shape;
}

function formatBackboardName(backboard) {
    return getDesignerCopy().backboards[backboard] || backboard;
}

function formatPowerAdapter(adapter) {
    return getDesignerCopy().powerAdapters[adapter] || adapter;
}

function formatHangingOption() {
    const selected = document.querySelector('input[name="hanging"]:checked');
    const value = selected?.value || 'none';

    if (value === 'wall') return getDesignerCopy().extras.hanging;
    if (value === 'sign') return isFrenchDesigner() ? 'Suspension de l’enseigne' : 'Sign hanging';
    return isFrenchDesigner() ? 'Aucune' : 'None';
}

function isRemoteDimmerSelected() {
    return Boolean(document.getElementById('remoteDimmer')?.checked);
}

function getSelectableOptionsSummary() {
    return {
        text: appState.text || CONFIG.defaultPlaceholderText,
        font: formatFontName(appState.fontKey),
        fontFamily: appState.fontFamily,
        color: appState.colorName,
        colorValue: appState.colorValue,
        multicolor: appState.multicolor,
        multicolorSelection: appState.multicolor
            ? Object.entries(appState.characterColors).map(([index, color]) => ({
                characterIndex: String(index),
                color
            }))
            : [],
        sizeName: appState.plan.name,
        widthInches: String(appState.plan.widthIn),
        heightInches: String(appState.plan.heightIn),
        indoorOrOutdoor: appState.type,
        cutConfiguration: formatShapeName(appState.cutTo),
        cutConfigurationId: appState.cutTo,
        backboardColor: formatBackboardName(appState.backboard),
        backboardColorId: appState.backboard,
        powerAdapter: formatPowerAdapter(appState.powerAdapter || 'canada'),
        powerAdapterId: appState.powerAdapter || 'canada',
        hangingOption: formatHangingOption(),
        remoteAndDimmer: isRemoteDimmerSelected(),
        extras: appState.extras.map(extra => ({
            id: extra.id,
            description: extra.description,
            price: String(extra.price ?? 0)
        }))
    };
}

function getFinalCheckoutPrice() {
    return appState.discountPrice;
}

function showModalError(msg) {
    const overlay = document.getElementById('previewModalOverlay');
    if (!overlay) return;
    let banner = overlay.querySelector('.modal-inline-error');
    if (!banner) {
        banner = document.createElement('div');
        banner.className = 'modal-inline-error';
        banner.setAttribute('role', 'alert');
        const footer = overlay.querySelector('.modal-footer');
        if (footer) footer.parentNode.insertBefore(banner, footer);
    }
    banner.textContent = msg;
    setTimeout(() => { if (banner.parentNode) banner.remove(); }, 4000);
}

async function proceedToCheckout() {
    if (!appState.text || !appState.text.trim()) {
        showModalError(getDesignerCopy().checkoutTextRequired);
        return;
    }
    if (!validateCustomSize({ focus: true })) {
        closePreviewModal();
        navigateToStep(2);
        return;
    }

    closePreviewModal();
    const btn = document.querySelector('.btn-final');
    const mobileBtn = document.getElementById('mobileNextBtn');

    if (btn) {
        btn.disabled = true;
        btn.textContent = getDesignerCopy().processing;
    }

    if (mobileBtn && appState.currentStep === 4) {
        mobileBtn.disabled = true;
        mobileBtn.textContent = getDesignerCopy().processing;
    }

    await captureSvgMarkup();
    const selectableOptions = getSelectableOptionsSummary();
    const finalCheckoutPrice = getFinalCheckoutPrice();

    const neonObjectPayload = {
        text: appState.text,
        font: appState.fontKey,
        fontFamily: appState.fontFamily,
        color: appState.colorName,
        colorValue: appState.colorValue,
        widthInches: selectableOptions.widthInches,
        heightInches: selectableOptions.heightInches,
        width: selectableOptions.widthInches,
        height: selectableOptions.heightInches,
        sizeName: selectableOptions.sizeName,
        plan: {
            ...appState.plan,
            widthIn: String(appState.plan.widthIn),
            heightIn: String(appState.plan.heightIn),
            basePrice: String(appState.plan.price),
            price: String(finalCheckoutPrice),
            finalPrice: String(finalCheckoutPrice)
        },
        lineHeight: 20,
        variantId: null,
        userHasEnteredText: appState.userHasEnteredText,
        extras: appState.extras,
        type: appState.type,
        indoorOrOutdoor: selectableOptions.indoorOrOutdoor,
        outdoorSurcharge: appState.outdoorSurcharge,
        rgbSurcharge: appState.rgbSurcharge,
        backboard: appState.backboard,
        backboardColor: selectableOptions.backboardColor,
        cutTo: appState.cutTo,
        cutConfiguration: selectableOptions.cutConfiguration,
        cutToPrice: appState.cutToPrice,
        powerAdapter: appState.powerAdapter || 'canada',
        powerAdapterLabel: selectableOptions.powerAdapter,
        hangingOption: selectableOptions.hangingOption,
        remoteAndDimmer: selectableOptions.remoteAndDimmer,
        multicolor: selectableOptions.multicolor,
        multicolorSelection: selectableOptions.multicolorSelection,
        selectableOptions,
        totalPrice: appState.totalPrice,
        discountPrice: finalCheckoutPrice,
        finalPrice: finalCheckoutPrice,
        checkoutPrice: finalCheckoutPrice,
        displayedPrice: finalCheckoutPrice,
        discountCode: appState.discountCode || '',
        discountApplied: appState.discountApplied || false,
        svgMarkup: appState.svgMarkup,
        previewPngData: appState.previewPngData,
        svgWidthPx: appState.svgWidthPx,
        svgHeightPx: appState.svgHeightPx
    };
    try {
        const idempotencyKey = `draft-order-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const apiBaseUrl = (window.scNeonConfig && window.scNeonConfig.apiBaseUrl || '').replace(/\/$/, '');
        const apiKey = window.scNeonConfig && window.scNeonConfig.apiKey || '';
        if (!apiBaseUrl || !apiKey) {
            throw new Error('The custom neon checkout is not configured.');
        }
        const response = await fetch(`${apiBaseUrl}/create-draft-order`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': apiKey,
                'X-Idempotency-Key': idempotencyKey
            },
            body: JSON.stringify(neonObjectPayload)
        });
        const data = await response.json();
        if (data.checkout_url) {
            window.location.href = data.checkout_url;
            return;
        }
        console.error('[checkout] API request failed with status', response.status);
        throw new Error(data.message || data.error || 'No checkout URL returned');
    } catch (err) {
        console.error('[checkout] Request failed.');
        alert(getDesignerCopy().checkoutError);
    }

    if (btn) {
        btn.disabled = false;
        btn.textContent = getDesignerCopy().previewAndBuy;
    }

    if (mobileBtn && appState.currentStep === 4) {
        mobileBtn.disabled = false;
        mobileBtn.textContent = getDesignerCopy().previewAndBuy;
    }
}

async function captureSvgMarkup() {
    const canvas = canvasInstances['neonCanvas4'] || canvasInstances['neonCanvas'];

    if (canvas) {
        appState.svgMarkup = await generatePreviewSVG(canvas);
        appState.previewPngData = await renderPreviewPng(appState.svgMarkup);
        appState.svgWidthPx = canvas.width;
        appState.svgHeightPx = canvas.height;
    }
}

async function renderPreviewPng(svgMarkup) {
    if (!svgMarkup) return '';

    const blob = new Blob([svgMarkup], { type: 'image/svg+xml;charset=utf-8' });
    const objectUrl = URL.createObjectURL(blob);
    try {
        const image = new Image();
        await new Promise((resolve, reject) => {
            image.onload = resolve;
            image.onerror = reject;
            image.src = objectUrl;
        });

        const sourceWidth = image.naturalWidth || 1200;
        const sourceHeight = image.naturalHeight || 700;
        const scale = Math.min(1, 1400 / sourceWidth, 900 / sourceHeight);
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(sourceWidth * scale));
        canvas.height = Math.max(1, Math.round(sourceHeight * scale));
        const context = canvas.getContext('2d');
        context.fillStyle = '#211b20';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL('image/png');
    } catch (error) {
        console.warn('[checkout] PNG preview could not be generated.', error);
        return '';
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}

function attachStepNavigationListeners() {
    document.querySelectorAll('.step-tab').forEach(tab => {
        tab.addEventListener('click', (e) => {
            e.stopPropagation();
            const step = parseInt(tab.getAttribute('data-step'));
            navigateToStep(step);
        });
    });


    window.goToStep = navigateToStep;


    setupMobilePanelToggle();


    document.querySelectorAll('.preview-eye-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            showPreviewModal();
        });
    });
}

function setupMobilePanelToggle() {
    const isMobile = () => window.innerWidth < 1200;


    for (let i = 1; i <= 4; i++) {
        const toggleBtn = document.getElementById(`mobileToggle${i === 1 ? '' : i}`);
        const handle = document.getElementById(`mobilePanelHandle${i === 1 ? '' : i}`);
        const stepContainer = document.getElementById(`step${i}`);

        if (!stepContainer) continue;
        const leftPanel = stepContainer.querySelector('.left-panel');
        const contentSection = leftPanel.querySelector('.content-section');

        if (toggleBtn && leftPanel && isMobile()) {
            toggleBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                leftPanel.classList.toggle('expanded');
            });
        }


        if (handle && leftPanel && isMobile()) {
            let startY = 0;
            let currentY = 0;
            let isDragging = false;

            handle.addEventListener('touchstart', (e) => {
                startY = e.touches[0].clientY;
                isDragging = false;
            }, { passive: true });

            handle.addEventListener('touchmove', (e) => {
                currentY = e.touches[0].clientY;
                const diff = Math.abs(currentY - startY);
                if (diff > 10) {
                    isDragging = true;
                }
            }, { passive: true });

            handle.addEventListener('touchend', (e) => {
                if (!isDragging) {

                    leftPanel.classList.toggle('expanded');
                } else {

                    const diff = currentY - startY;
                    if (Math.abs(diff) > 50) {
                        if (diff > 0) {

                            leftPanel.classList.remove('expanded');
                        } else {

                            leftPanel.classList.add('expanded');
                        }
                    }
                }
                isDragging = false;
            }, { passive: true });


            handle.addEventListener('click', () => {
                if (isMobile()) {
                    leftPanel.classList.toggle('expanded');
                }
            });
        }

        // Add swipe gesture detection on left-panel
        if (leftPanel) {
            let touchStartY = 0;
            let touchStartX = 0;
            let touchEndY = 0;
            let touchEndX = 0;
            let isSwiping = false;

            leftPanel.addEventListener('touchstart', (e) => {
                if (!isMobile()) return;
                touchStartY = e.touches[0].clientY;
                touchStartX = e.touches[0].clientX;
                isSwiping = false;
            }, { passive: true });

            leftPanel.addEventListener('touchmove', (e) => {
                if (!isMobile()) return;
                touchEndY = e.touches[0].clientY;
                touchEndX = e.touches[0].clientX;
                const diffY = Math.abs(touchEndY - touchStartY);
                const diffX = Math.abs(touchEndX - touchStartX);
                // Only consider it a swipe if vertical movement is greater than horizontal
                if (diffY > 30 && diffY > diffX) {
                    isSwiping = true;
                }
            }, { passive: true });

            leftPanel.addEventListener('touchend', (e) => {
                if (!isMobile() || !isSwiping) {
                    isSwiping = false;
                    return;
                }

                const verticalDiff = touchStartY - touchEndY;
                const isExpanded = leftPanel.classList.contains('expanded');
                const scrollTop = contentSection ? contentSection.scrollTop : 0;

                // Swipe up (vertical diff > 0) - expand when collapsed
                if (verticalDiff > 50 && !isExpanded) {
                    leftPanel.classList.add('expanded');
                }
                // Swipe down (vertical diff < 0) - collapse when expanded and at top
                else if (verticalDiff < -300 && isExpanded && scrollTop === 0) {
                    leftPanel.classList.remove('expanded');
                }

                isSwiping = false;
            }, { passive: true });
        }
    }

    // Add click listeners to step tabs to preserve expanded state
    document.querySelectorAll('.step-tab').forEach(tab => {
        tab.addEventListener('click', () => {
            if (!isMobile()) return;

            // Expand ALL left panels immediately
            document.querySelectorAll('.left-panel').forEach(leftPanel => {
                leftPanel.classList.add('expanded');
            });

            const stepNum = parseInt(tab.getAttribute('data-step'));
            const stepContainer = document.getElementById(`step${stepNum}`);

        });
    });

    window.addEventListener('resize', () => {
        if (!isMobile()) {
            document.querySelectorAll('.left-panel').forEach(panel => {
                panel.classList.remove('expanded');
            });
        }
    });
}

function navigateToStep(stepNumber) {

    if (stepNumber > 1 && appState.currentStep === 1 && !validateSignText({ focus: true })) {
        return;
    }
    if (stepNumber > 2 && appState.currentStep === 2 && !validateCustomSize({ focus: true })) {
        return;
    }

    document.querySelectorAll('.step-container').forEach(container => {
        container.classList.remove('active');
    });


    const targetStep = document.getElementById(`step${stepNumber}`);
    if (targetStep) {
        targetStep.classList.add('active');
    }

    appState.currentStep = stepNumber;
    updateStepTabsUI();
    hideColorPopup();
    renderAllPreviews();


    const isMobile = window.innerWidth < 1200;
    if (isMobile) {
        const leftPanel = targetStep.querySelector('.left-panel');
        if (leftPanel && leftPanel.classList.contains('expanded')) {

        } else if (leftPanel) {


        }
    } else {
        const toolScope = document.querySelector('.neon-tool-scope');
        if (toolScope) {
            const targetTop = Math.max(0, Math.round(window.scrollY + toolScope.getBoundingClientRect().top));
            window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
        }
    }
}

function updateStepTabsUI() {
    document.querySelectorAll('.step-tab').forEach(tab => {
        const step = parseInt(tab.getAttribute('data-step'));
        tab.classList.remove('active', 'completed');

        if (step < appState.currentStep) {
            tab.classList.add('completed');
        } else if (step === appState.currentStep) {
            tab.classList.add('active');
        }
    });
}

function attachPreviewControlListeners() {
    for (let step = 1; step <= 4; step++) {
        const container = document.getElementById(`step${step}`);
        if (!container) continue;


        const neonToggle = container.querySelector(`#neonToggle${step === 1 ? '' : step}`);
        if (neonToggle) {
            neonToggle.addEventListener('change', (e) => {
                appState.neonGlowEnabled = e.target.checked;
                renderAllPreviews();
            });
        }


        const modeBtns = container.querySelectorAll('.mode-btn');
        modeBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const parent = btn.closest('.theme-mode-toggle');
                parent.querySelectorAll('.mode-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                appState.themeMode = btn.getAttribute('data-mode');
                updateBackgroundTheme();
                renderAllPreviews();
            });
        });


        const saveBtn = document.getElementById(`saveBtn${step}`);
        if (saveBtn) {
            saveBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const rect = saveBtn.getBoundingClientRect();
                showExportMenu(step, rect);
            });
        }
    }
}

function updateBackgroundTheme() {
    for (let i = 1; i <= 4; i++) {
        const wrapper = document.getElementById(`bgImageWrapper${i === 1 ? '' : i}`);
        if (wrapper) {
            wrapper.classList.remove('light-mode', 'dark-mode');
            wrapper.classList.add(`${appState.themeMode}-mode`);
        }
    }
}

// Load the selected font as a self-contained data URL. Shopify can serve an
// asset whose filename ends in .ttf as WOFF2, so use the response bytes (not
// the filename) to declare the correct format in the exported SVG.
async function getFontAsBase64(fontFamily) {
    try {
        const base = (window.neonAssetsBaseUrl || '/cdn/shop/t/');
        const fontPath = `${base}${fontFamily}.ttf`;
        const response = await fetch(fontPath);
        if (!response.ok) {
            console.warn(`Failed to load font: ${fontPath}`);
            return null;
        }

        const fontBuffer = await response.arrayBuffer();
        const header = new Uint8Array(fontBuffer, 0, Math.min(4, fontBuffer.byteLength));
        const signature = String.fromCharCode(...header);
        const responseType = (response.headers.get('content-type') || '').toLowerCase();
        let mimeType = 'font/ttf';
        let cssFormat = 'truetype';

        if (signature === 'wOF2' || responseType.includes('woff2')) {
            mimeType = 'font/woff2';
            cssFormat = 'woff2';
        } else if (signature === 'wOFF' || responseType.includes('woff')) {
            mimeType = 'font/woff';
            cssFormat = 'woff';
        } else if (signature === 'OTTO' || responseType.includes('otf')) {
            mimeType = 'font/otf';
            cssFormat = 'opentype';
        }

        const blob = new Blob([fontBuffer], { type: mimeType });
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve({
                dataUrl: reader.result,
                format: cssFormat
            });
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error loading font:', error);
        return null;
    }
}

// Helper function to embed font in SVG
async function embedFontInSVG(svgString, fontFamily) {
    if (!fontFamily) return svgString;

    const embeddedFont = await getFontAsBase64(fontFamily);
    if (!embeddedFont) return svgString;

    // Create font-face style
    const fontStyle = `
        <defs>
            <style type="text/css">
                @font-face {
                    font-family: ${fontFamily};
                    src: url('${embeddedFont.dataUrl}') format('${embeddedFont.format}');
                }
            </style>
        </defs>
    `;

    // Insert after the opening <svg> tag
    svgString = svgString.replace(/(<svg[^>]*>)/, `$1${fontStyle}`);

    return svgString;
}

function showExportMenu(stepNumber, buttonRect) {
    // Remove existing menu if any
    const existingMenu = document.querySelector('.export-format-menu');
    if (existingMenu) {
        existingMenu.remove();
    }

    // Create menu
    const menu = document.createElement('div');
    menu.className = 'export-format-menu';
    menu.style.cssText = `
        position: fixed;
        top:0,
        background: #1a1a1a;
        border: 0;
        border-radius: 4px;
        padding: 8px;
        z-index: 10000;
        box-shadow: none;
        min-width: 180px;
    `;

    // Position menu near the button
    menu.style.left = `${buttonRect.left}px`;
    menu.style.top = `${buttonRect.top - 100}px`;

    // Add export options
    menu.innerHTML = `
        <button class="export-option" type="button" data-format="svg" style="
            display: block;
            width: 100%;
            padding: 10px 12px;
            background: transparent;
            border: none;
            color: #fff;
            text-align: left;
            cursor: pointer;
            border-radius: 4px;
            font-size: 14px;
            margin-bottom: 4px;
        ">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display: inline-block; vertical-align: middle; margin-right: 8px;">
                <path d="M2 2L14 2L14 14L2 14Z" stroke="currentColor" stroke-width="1.5" fill="none"/>
                <path d="M5 6L8 9L11 6" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            ${getDesignerCopy().exportSvg}
        </button>
        <button class="export-option" type="button" data-format="png" style="
            display: block;
            width: 100%;
            padding: 10px 12px;
            background: transparent;
            border: none;
            color: #fff;
            text-align: left;
            cursor: pointer;
            border-radius: 4px;
            font-size: 14px;
        ">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display: inline-block; vertical-align: middle; margin-right: 8px;">
                <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/>
                <circle cx="8" cy="8" r="2" fill="currentColor"/>
            </svg>
            ${getDesignerCopy().exportPng}
        </button>
    `;

    document.body.appendChild(menu);

    // Add hover effects
    menu.querySelectorAll('.export-option').forEach(option => {
        option.addEventListener('mouseenter', () => {
            option.style.background = '#333';
        });
        option.addEventListener('mouseleave', () => {
            option.style.background = 'transparent';
        });
        option.addEventListener('click', () => {
            const format = option.dataset.format;
            menu.remove();
            if (format === 'svg') {
                exportPreviewAsSVG(stepNumber);
            } else {
                exportPreviewImage(stepNumber);
            }
        });
    });

    // Close menu when clicking outside
    setTimeout(() => {
        const closeMenu = (e) => {
            if (!menu.contains(e.target)) {
                menu.remove();
                document.removeEventListener('click', closeMenu);
            }
        };
        document.addEventListener('click', closeMenu);
    }, 100);
}

async function exportPreviewAsSVG(stepNumber) {
    const canvasId = stepNumber === 1 ? 'neonCanvas' : `neonCanvas${stepNumber}`;
    const canvas = canvasInstances[canvasId];

    if (!canvas) {
        alert('Canvas not found');
        return;
    }

    const objects = canvas.getObjects();

    if (objects.length === 0) {
        alert('Please add some text to your sign before exporting');
        return;
    }

    // Calculate bounding box of all objects
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

    objects.forEach(obj => {
        const bounds = obj.getBoundingRect();
        minX = Math.min(minX, bounds.left);
        minY = Math.min(minY, bounds.top);
        maxX = Math.max(maxX, bounds.left + bounds.width);
        maxY = Math.max(maxY, bounds.top + bounds.height);
    });

    // Add padding
    const padding = 80;
    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(canvas.width, maxX + padding);
    maxY = Math.min(canvas.height, maxY + padding);

    const width = maxX - minX;
    const height = maxY - minY;

    // Get SVG string from Fabric.js
    let svgString = canvas.toSVG({
        viewBox: {
            x: minX,
            y: minY,
            width: width,
            height: height
        },
        width: width,
        height: height,
        suppressPreamble: false
    });

    // Add background color based on current theme
    const isDarkMode = document.querySelector('.mode-btn.active[data-mode="dark"]') !== null;
    const bgColor = isDarkMode ? '#000000' : '#ffffff';

    // Insert background rectangle after the opening <svg> tag
    // svgString = svgString.replace(
    //     /(<svg[^>]*>)/,
    //     `$1<rect x="0" y="0" width="${width}" height="${height}" fill="${bgColor}"/>`
    // );

    // Embed font in SVG
    svgString = await embedFontInSVG(svgString, appState.fontFamily);

    // Create blob and download
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.download = `neon-sign-${Date.now()}.svg`;
    link.href = url;
    link.click();

    // Clean up
    setTimeout(() => URL.revokeObjectURL(url), 100);
}

async function exportPreviewImage(stepNumber) {
    const canvasId = stepNumber === 1 ? 'neonCanvas' : `neonCanvas${stepNumber}`;
    const canvas = canvasInstances[canvasId];

    if (!canvas) {
        alert('Canvas not found');
        return;
    }

    const objects = canvas.getObjects();

    if (objects.length === 0) {
        alert('Please add some text to your sign before exporting');
        return;
    }

    // Generate SVG string with embedded font
    const svgString = await generatePreviewSVG(canvas);
    if (!svgString) {
        alert('Failed to generate preview');
        return;
    }

    // Convert SVG to PNG using high-quality rendering
    // Create a blob from SVG string
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // Create an Image element to load the SVG
    const img = new Image();

    img.onload = function () {
        // Use 6x multiplier for high-resolution, print-quality output
        const multiplier = 6;

        // Create a temporary canvas to hold the high-res image
        const tempCanvas = document.createElement('canvas');
        const tempCtx = tempCanvas.getContext('2d');

        // Set temp canvas size to match SVG dimensions at high resolution
        tempCanvas.width = img.width * multiplier;
        tempCanvas.height = img.height * multiplier;

        // Enable image smoothing for better quality
        tempCtx.imageSmoothingEnabled = true;
        tempCtx.imageSmoothingQuality = 'high';

        // Draw the SVG image onto the canvas at high resolution
        tempCtx.drawImage(img, 0, 0, img.width * multiplier, img.height * multiplier);

        // Export as high-quality PNG
        const dataURL = tempCanvas.toDataURL('image/png', 1.0);

        const link = document.createElement('a');
        link.download = `neon-sign-preview-${Date.now()}.png`;
        link.href = dataURL;
        link.click();

        // Clean up
        URL.revokeObjectURL(url);
    };

    img.onerror = function () {
        alert('Failed to convert SVG to PNG');
        URL.revokeObjectURL(url);
    };

    // Load the SVG
    img.src = url;
}

function renderCanvasPreview(canvas) {
    if (!canvas) return;

    canvas.clear();

    // Reset viewport transform to ensure canvas is properly centered after refresh
    canvas.viewportTransform = [1, 0, 0, 1, 0, 0];

    const displayText = appState.text || CONFIG.defaultPlaceholderText;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const isMobile = window.innerWidth < CONFIG.mobileBreakpoint;

    // Calculate proportional font size based on plan dimensions
    const planWidth = appState.plan.widthIn || 17;
    const planHeight = appState.plan.heightIn || 10;
    const baseFontSize = appState.fontSizePx;

    // Scale font size proportionally with plan size (relative to MINI: 17x10)
    const sizeRatio = Math.sqrt((planWidth * planHeight) / (17 * 10));
    let renderingFontSize = baseFontSize * sizeRatio;

    if (isMobile) {
        renderingFontSize = renderingFontSize * 2.3;
    }

    // Create a temporary text object to measure dimensions
    const lineHeightMultiplier = getLineHeightMultiplier();
    const tempText = new fabric.Text(displayText, {
        fontFamily: appState.fontFamily,
        fontSize: renderingFontSize,
        textAlign: 'center',
        lineHeight: lineHeightMultiplier
    });

    // Check if text with measurements would exceed canvas bounds
    // Increase space to ensure measurements never overlap text
    const MEASUREMENT_SPACE = isMobile ? 250 : 350; // Increased space for measurement rulers and labels
    const textBounds = tempText.getBoundingRect();
    const requiredWidth = textBounds.width + MEASUREMENT_SPACE;
    const requiredHeight = textBounds.height + MEASUREMENT_SPACE;

    // Calculate scale factor to fit content within canvas
    // Use conservative scaling (0.75) to ensure everything fits with padding
    let scaleFactor = 1;
    if (requiredWidth > canvas.width * 0.75 || requiredHeight > canvas.height * 0.75) {
        const widthScale = (canvas.width * 0.75) / requiredWidth;
        const heightScale = (canvas.height * 0.75) / requiredHeight;
        scaleFactor = Math.min(widthScale, heightScale);
        renderingFontSize = renderingFontSize * scaleFactor;
    }

    if (appState.multicolor) {
        renderMulticolorText(canvas, displayText, centerX, centerY, renderingFontSize);
    } else {
        const textConfig = {
            left: centerX,
            top: centerY,
            originX: 'center',
            originY: 'center',
            textAlign: 'center',
            fontFamily: appState.fontFamily,
            fontSize: renderingFontSize,
            lineHeight: lineHeightMultiplier,
            fill: appState.colorValue,
            selectable: false,
            objectCaching: true
        };


        if (appState.neonGlowEnabled) {
            textConfig.shadow = {
                color: appState.colorValue,
                blur: 45 * scaleFactor,
                offsetX: 0,
                offsetY: 0
            };
        } else {
            textConfig.opacity = 0.3;
        }

        const textObject = new fabric.Text(displayText, textConfig);
        canvas.add(textObject);
        drawMeasurementOverlays(canvas, textObject);
    }

    // Use requestRenderAll to batch rendering and avoid forced reflow
    canvas.requestRenderAll();
}

function renderMulticolorText(canvas, text, centerX, centerY, renderingFontSize) {

    const useFontSize = renderingFontSize || appState.fontSizePx;

    // Split text into lines to preserve line breaks
    const lines = text.split('\n');

    // Create a temp text to measure overall dimensions
    const lineHeightMultiplier = getLineHeightMultiplier();
    const tempText = new fabric.Text(text, {
        fontFamily: appState.fontFamily,
        fontSize: useFontSize,
        lineHeight: lineHeightMultiplier
    });

    const totalWidth = tempText.width;
    const totalHeight = tempText.height;

    // Calculate line height - multiply by font size to get actual pixel height
    const lineHeightPx = lineHeightMultiplier * useFontSize;

    // Calculate starting Y position to center all lines
    const totalLinesHeight = lines.length * lineHeightPx;
    let currentY = centerY - (totalLinesHeight / 2) + (lineHeightPx / 2);

    // Track character index across all lines
    let globalCharIndex = 0;

    // Collect all objects to add at once (batch operation)
    const objectsToAdd = [];

    // Process each line
    lines.forEach((line, lineIndex) => {
        // Measure the width of this line
        const tempLineText = new fabric.Text(line, {
            fontFamily: appState.fontFamily,
            fontSize: useFontSize
        });
        const lineWidth = tempLineText.width;

        // Calculate starting X position for this line
        let startX = centerX - (lineWidth / 2);

        // Render each character in this line
        for (let i = 0; i < line.length; i++) {
            const char = line[i];

            const charColor = appState.characterColors[globalCharIndex] || appState.colorValue;
            const isSelected = appState.selectedCharIndex === globalCharIndex;

            const charConfig = {
                fontFamily: appState.fontFamily,
                fontSize: useFontSize,
                lineHeight: lineHeightMultiplier,
                fill: charColor,
                selectable: false,
                charSpacing: 0,
                objectCaching: true
            };

            if (appState.neonGlowEnabled) {
                charConfig.shadow = {
                    color: charColor,
                    blur: 45,
                    offsetX: 0,
                    offsetY: 0
                };
            } else {
                charConfig.opacity = 0.3;
            }

            if (isSelected) {
                charConfig.stroke = '#C8FF00';
                charConfig.strokeWidth = 4;
                charConfig.paintFirst = 'stroke';

                if (appState.neonGlowEnabled) {
                    charConfig.shadow = {
                        color: '#C8FF00',
                        blur: 60,
                        offsetX: 0,
                        offsetY: 0
                    };
                }
            }

            const charObj = new fabric.Text(char, charConfig);
            charObj.charIndex = globalCharIndex;

            const charWidth = charObj.width;

            charObj.set({
                left: startX + (charWidth / 2),
                top: currentY,
                originX: 'center',
                originY: 'center'
            });

            // Add to batch array instead of directly to canvas
            objectsToAdd.push(charObj);

            startX += charWidth;
            globalCharIndex++;
        }

        // Account for the newline character in the character index
        // (except for the last line)
        if (lineIndex < lines.length - 1) {
            globalCharIndex++;
        }

        // Move to next line
        currentY += lineHeightPx;
    });

    // Batch add all character objects at once for better performance
    if (objectsToAdd.length > 0) {
        canvas.add(...objectsToAdd);
    }

    // Include the tuned per-font line spacing in the measurement rulers.
    const objectBounds = objectsToAdd.map(object => object.getBoundingRect());
    const minLeft = objectBounds.length ? Math.min(...objectBounds.map(bounds => bounds.left)) : centerX;
    const minTop = objectBounds.length ? Math.min(...objectBounds.map(bounds => bounds.top)) : centerY;
    const maxRight = objectBounds.length ? Math.max(...objectBounds.map(bounds => bounds.left + bounds.width)) : centerX;
    const maxBottom = objectBounds.length ? Math.max(...objectBounds.map(bounds => bounds.top + bounds.height)) : centerY;

    const boundingBox = {
        getBoundingRect: function () {
            return {
                left: minLeft,
                top: minTop,
                width: maxRight - minLeft,
                height: maxBottom - minTop
            };
        }
    };

    drawMeasurementOverlays(canvas, boundingBox);
}

function drawMeasurementOverlays(canvas, textObject) {
    const scaleColor = appState.themeMode === 'dark'
        ? 'rgba(255, 255, 255, 0.6)'
        : 'rgba(0, 0, 0, 0.7)';

    const textColor = appState.themeMode === 'dark' ? '#000000' : '#FFFFFF';

    const bounds = textObject.getBoundingRect();
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    // Calculate safe margins to keep rulers within canvas
    const CANVAS_MARGIN = 60; // Minimum margin from canvas edges
    const MIN_PADDING = 35; // Minimum padding from text - closer but not too close

    const sizeFactor = bounds.width / 400;
    let padding = Math.max(MIN_PADDING, Math.min(80, 50 * sizeFactor));
    const tickLength = Math.max(8, Math.min(15, 10 * sizeFactor));

    // Increase font size on mobile for better readability
    const isMobile = window.innerWidth < CONFIG.mobileBreakpoint;
    const labelFontSize = isMobile
        ? Math.max(22, Math.min(34, 24 * sizeFactor))
        : Math.max(16, Math.min(24, 18 * sizeFactor));

    // Check if text + rulers would exceed canvas bounds and scale if needed
    const textWithRulerHeight = bounds.top + bounds.height + padding + labelFontSize + 40;
    const textWithRulerWidth = bounds.left + bounds.width + padding + labelFontSize * 3 + 40;

    // If content exceeds canvas, reduce padding but ensure minimum distance
    if (textWithRulerHeight > canvas.height - CANVAS_MARGIN) {
        padding = Math.max(MIN_PADDING, canvas.height - bounds.top - bounds.height - labelFontSize - CANVAS_MARGIN - 40);
    }
    if (textWithRulerWidth > canvas.width - CANVAS_MARGIN) {
        padding = Math.max(MIN_PADDING, canvas.width - bounds.left - bounds.width - labelFontSize * 3 - CANVAS_MARGIN - 40);
    }

    // Ensure padding is never less than minimum to prevent text overlap
    padding = Math.max(MIN_PADDING, padding);

    // Horizontal measurement line (width) - positioned below text with safe distance
    // Always maintain minimum padding - never allow line to touch text
    const hLineY = bounds.top + bounds.height + padding;
    // Align measurement line closely with text bounds (minimal extension)
    const hStartX = Math.max(bounds.left, CANVAS_MARGIN);
    const hEndX = Math.min(bounds.left + bounds.width, canvas.width - CANVAS_MARGIN);

    const horizLine = new fabric.Line([hStartX, hLineY, hEndX, hLineY], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    });
    canvas.add(horizLine);

    // Horizontal tick marks
    canvas.add(new fabric.Line([hStartX, hLineY - tickLength, hStartX, hLineY + tickLength], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    }));

    canvas.add(new fabric.Line([hEndX, hLineY - tickLength, hEndX, hLineY + tickLength], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    }));

    // Width label - positioned safely below the measurement line
    const widthLabelTop = Math.min(hLineY + 12, canvas.height - labelFontSize - 15);
    const widthLabel = new fabric.Text(`${appState.plan.widthIn}"`, {
        left: centerX,
        top: widthLabelTop,
        originX: 'center',
        originY: 'top',
        fontSize: labelFontSize,
        fill: textColor,
        fontFamily: "Barcelona",
        fontWeight: 700,
        selectable: false,
        backgroundColor: appState.themeMode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.6)',
        padding: 4
    });
    canvas.add(widthLabel);

    // Vertical measurement line (height) - positioned to the right of text with safe distance
    // Always maintain minimum padding - never allow line to touch text
    const vLineX = bounds.left + bounds.width + padding;
    // Align measurement line closely with text bounds (minimal extension)
    const vStartY = Math.max(bounds.top, CANVAS_MARGIN);
    const vEndY = Math.min(bounds.top + bounds.height, canvas.height - CANVAS_MARGIN);

    const vertLine = new fabric.Line([vLineX, vStartY, vLineX, vEndY], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    });
    canvas.add(vertLine);

    // Vertical tick marks
    canvas.add(new fabric.Line([vLineX - tickLength, vStartY, vLineX + tickLength, vStartY], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    }));

    canvas.add(new fabric.Line([vLineX - tickLength, vEndY, vLineX + tickLength, vEndY], {
        stroke: scaleColor,
        strokeWidth: 2,
        selectable: false
    }));

    // Height label - positioned safely to the right of the measurement line
    const heightLabelLeft = Math.min(vLineX + 12, canvas.width - labelFontSize * 2.5 - 15);
    const heightLabel = new fabric.Text(`${appState.plan.heightIn}"`, {
        left: heightLabelLeft,
        top: centerY,
        originX: 'left',
        originY: 'center',
        fontSize: labelFontSize,
        fill: textColor,
        fontFamily: "Barcelona",
        fontWeight: 700,
        selectable: false,
        backgroundColor: appState.themeMode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.6)',
        padding: 4
    });
    canvas.add(heightLabel);
}

function getMeasuredDimensions() {
    // Get text and split into lines to find max line length
    const text = appState.text || CONFIG.defaultPlaceholderText;
    const lines = text.split('\n');

    // Find the longest line
    let maxCharacters = 0;
    lines.forEach(line => {
        maxCharacters = Math.max(maxCharacters, line.length);
    });

    // If no characters, use default placeholder length
    if (maxCharacters === 0) {
        maxCharacters = CONFIG.defaultPlaceholderText.length;
    }

    // Calculate base dimensions using character count (2.5 inches per character)
    // This matches the logic from referencejs.js
    const baseWidthInches = maxCharacters * 2.5;

    // Apply font size scaling factor
    // Base font size is 38px, so we scale proportionally
    const fontSizeScaleFactor = appState.fontSizePx / CONFIG.baseFontSize;
    const scaledWidth = baseWidthInches * fontSizeScaleFactor;

    // Calculate height proportionally based on aspect ratio
    // Using measured aspect ratio that considers actual text rendering
    // For multi-line text, height increases
    const lineCount = lines.length;
    const aspectRatio = 2.3; // Width to height ratio (typical for text)
    const baseHeight = scaledWidth / aspectRatio;

    // Add extra height for multi-line text
    const lineHeightFactor = lineCount > 1 ? 1 + ((lineCount - 1) * 0.15) : 1;
    const scaledHeight = baseHeight * lineHeightFactor;

    return {
        widthIn: Math.max(23, Math.round(scaledWidth)), // Minimum width of 23 inches
        heightIn: Math.max(10, Math.round(scaledHeight)) // Minimum height of 10 inches
    };
}




window.addEventListener('resize', debounce(() => {
    renderAllPreviews();
    if (mobileDecisions.length) {
        activateMobileDecision(mobileDecisionIndex);
    }
    updateMobileFooter();
}, 250));




let touchStartY = 0;
let touchCurrentY = 0;
let isDragging = false;
const DRAG_THRESHOLD = 50;
let mobileDecisionIndex = 0;
let mobileDecisions = [];
let guidedViewportTimers = [];

function isMobileDecisionFlowActive() {
    return window.innerWidth < 1200 && mobileDecisions.length > 0;
}

function alignGuidedDesignerViewport() {
    if (!isMobileDecisionFlowActive()) return;

    const toolScope = document.querySelector('.neon-tool-scope');
    if (!toolScope) return;

    const targetTop = Math.max(0, Math.round(window.scrollY + toolScope.getBoundingClientRect().top));
    if (Math.abs(window.scrollY - targetTop) > 1) {
        window.scrollTo({ top: targetTop, left: 0, behavior: 'auto' });
    }
}

function stabilizeGuidedDesignerViewport({ dismissKeyboard = false } = {}) {
    if (!isMobileDecisionFlowActive()) return;

    const activeElement = document.activeElement;
    if (dismissKeyboard && activeElement && activeElement.matches('input, textarea, select, [contenteditable="true"]')) {
        activeElement.blur();
    }

    guidedViewportTimers.forEach(timer => clearTimeout(timer));
    guidedViewportTimers = [];
    alignGuidedDesignerViewport();
    requestAnimationFrame(alignGuidedDesignerViewport);

    // Mobile browsers restore the visual viewport asynchronously after the
    // keyboard closes. Re-align after both common viewport-settle points.
    [120, 320].forEach(delay => {
        guidedViewportTimers.push(setTimeout(alignGuidedDesignerViewport, delay));
    });
}

function bindGuidedViewportStability(toolScope) {
    if (!toolScope || toolScope.dataset.guidedViewportBound) return;
    toolScope.dataset.guidedViewportBound = 'true';
    let maximumVisualViewportHeight = window.visualViewport?.height || window.innerHeight;

    const engageDesigner = () => {
        if (!isMobileDecisionFlowActive()) return;
        toolScope.classList.add('is-guided-viewport-engaged');
        alignGuidedDesignerViewport();
        requestAnimationFrame(alignGuidedDesignerViewport);
        setTimeout(alignGuidedDesignerViewport, 60);
    };

    toolScope.addEventListener('pointerdown', engageDesigner, { capture: true, passive: true });
    toolScope.addEventListener('focusin', engageDesigner, { passive: true });

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', () => {
            maximumVisualViewportHeight = Math.max(maximumVisualViewportHeight, window.visualViewport.height);
            const keyboardIsClosed = window.visualViewport.height >= maximumVisualViewportHeight - 4;
            if (keyboardIsClosed && toolScope.classList.contains('is-guided-viewport-engaged')) {
                setTimeout(alignGuidedDesignerViewport, 60);
            }
        }, { passive: true });
    }
}

function getMobileDecisionCopy() {
    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');

    if (isFrench) {
        return {
            step: '\u00c9tape',
            back: 'Retour',
            continue: 'Continuer',
            review: 'Voir et acheter',
            total: 'Prix total',
            decisions: {
                text: ['Saisissez votre texte', 'Inscrivez exactement le message qui doit appara\u00eetre sur votre enseigne.'],
                font: ['Choisissez votre police', 'Comparez les styles et choisissez celui qui correspond le mieux \u00e0 votre id\u00e9e.'],
                color: ['Choisissez votre couleur', 'S\u00e9lectionnez la couleur DEL qui convient \u00e0 votre espace ou \u00e0 votre marque.'],
                size: ['Choisissez votre taille', 'Comparez les dimensions recommand\u00e9es ou entrez une taille personnalis\u00e9e.'],
                location: ['O\u00f9 sera install\u00e9e l\u2019enseigne?', 'Choisissez une construction int\u00e9rieure ou ext\u00e9rieure.'],
                shape: ['Choisissez la forme de l\u2019acrylique', 'S\u00e9lectionnez la d\u00e9coupe qui encadrera le mieux votre motif.'],
                backboard: ['Choisissez la finition de l\u2019acrylique', 'Choisissez une finition transparente, blanche, noire, argent ou or.'],
                power: ['Confirmez l\u2019adaptateur', 'Votre enseigne comprend un adaptateur compatible au Canada.'],
                hanging: ['Choisissez la fixation', 'Indiquez comment vous pr\u00e9voyez installer ou suspendre votre enseigne.'],
                extras: ['Finalisez vos options', 'Ajoutez les derni\u00e8res options, puis v\u00e9rifiez votre prix avant de continuer.']
            }
        };
    }

    return {
        step: 'Step',
        back: 'Back',
        continue: 'Continue',
        review: 'Review & buy',
        total: 'Total price',
        decisions: {
            text: ['Enter your text', 'Type the exact wording you want to see on your sign.'],
            font: ['Choose your font', 'Compare styles and select the one that best matches your idea.'],
            color: ['Choose your colour', 'Select the LED colour that suits your space or brand.'],
            size: ['Choose your size', 'Compare recommended dimensions or enter a custom size.'],
            location: ['Where will your sign go?', 'Choose the correct construction for indoor or outdoor use.'],
            shape: ['Choose the acrylic shape', 'Select the cut that will frame your design best.'],
            backboard: ['Choose the acrylic finish', 'Choose clear, white, black, silver or gold acrylic.'],
            power: ['Confirm your power adapter', 'Your sign includes a power adapter suitable for Canada.'],
            hanging: ['Choose a mounting option', 'Tell us how you plan to mount or hang your sign.'],
            extras: ['Finalise your options', 'Add any final options and check your price before continuing.']
        }
    };
}

function createMobileDecision(parent, nodes, step, key) {
    if (!parent || !nodes.length) return;

    const wrapper = document.createElement('section');
    wrapper.className = 'mobile-decision-panel';
    wrapper.dataset.mobileDecision = key;
    wrapper.dataset.parentStep = String(step);
    wrapper.setAttribute('aria-hidden', 'true');

    parent.insertBefore(wrapper, nodes[0]);
    nodes.forEach(node => wrapper.appendChild(node));
    mobileDecisions.push({ key, step, element: wrapper });
}

function getNodesBetween(children, startNode, endNode) {
    const startIndex = children.indexOf(startNode);
    const endIndex = endNode ? children.indexOf(endNode) : children.length;
    if (startIndex < 0 || endIndex < 0 || endIndex <= startIndex) return [];
    return children.slice(startIndex, endIndex);
}

function buildMobileDecisionPanels() {
    if (document.querySelector('[data-mobile-decision]')) return;

    const step1Content = document.querySelector('#step1 .content-section');
    const step1Children = step1Content ? Array.from(step1Content.children) : [];
    const step1Headings = step1Children.filter(child => child.matches('h3.section-title'));
    if (step1Headings.length >= 3) {
        createMobileDecision(step1Content, getNodesBetween(step1Children, step1Headings[0], step1Headings[1]), 1, 'text');
        createMobileDecision(step1Content, getNodesBetween(step1Children, step1Headings[1], step1Headings[2]), 1, 'font');
        createMobileDecision(step1Content, getNodesBetween(step1Children, step1Headings[2], null), 1, 'color');
    }

    const step2Content = document.querySelector('#step2 .content-section');
    const step2Children = step2Content ? Array.from(step2Content.children) : [];
    const step2Headings = step2Children.filter(child => child.matches('h3.section-title'));
    if (step2Children.length && step2Headings.length >= 2) {
        createMobileDecision(step2Content, getNodesBetween(step2Children, step2Children[0], step2Headings[1]), 2, 'size');
        createMobileDecision(step2Content, getNodesBetween(step2Children, step2Headings[1], null), 2, 'location');
    }

    const step3Content = document.querySelector('#step3 .content-section');
    const step3Children = step3Content ? Array.from(step3Content.children) : [];
    const backboardHeader = step3Children.find(child => child.matches('.section-header-with-link'));
    if (step3Children.length && backboardHeader) {
        createMobileDecision(step3Content, getNodesBetween(step3Children, step3Children[0], backboardHeader), 3, 'shape');
        createMobileDecision(step3Content, getNodesBetween(step3Children, backboardHeader, null), 3, 'backboard');
    }

    const step4Content = document.querySelector('#step4 .content-section');
    const step4Children = step4Content ? Array.from(step4Content.children) : [];
    const step4Headings = step4Children.filter(child => child.matches('h3.section-title'));
    if (step4Headings.length >= 3) {
        createMobileDecision(step4Content, getNodesBetween(step4Children, step4Headings[0], step4Headings[1]), 4, 'power');
        createMobileDecision(step4Content, getNodesBetween(step4Children, step4Headings[1], step4Headings[2]), 4, 'hanging');
        createMobileDecision(step4Content, getNodesBetween(step4Children, step4Headings[2], null), 4, 'extras');
    }
}

function createMobileDecisionHeaders() {
    document.querySelectorAll('.step-container .left-panel').forEach(panel => {
        if (panel.querySelector('.mobile-decision-progress')) return;

        const header = document.createElement('div');
        header.className = 'mobile-decision-progress';
        header.setAttribute('aria-live', 'polite');
        header.innerHTML = `
            <div class="mobile-decision-progress__meta">
                <span class="mobile-decision-progress__count"></span>
                <span class="mobile-decision-progress__percent"></span>
            </div>
            <div class="mobile-decision-progress__track" aria-hidden="true">
                <span class="mobile-decision-progress__fill"></span>
            </div>
            <div class="mobile-decision-progress__title" role="heading" aria-level="2"></div>
            <p class="mobile-decision-progress__hint"></p>
        `;

        const content = panel.querySelector('.content-section');
        panel.insertBefore(header, content);
    });
}

function activateMobileDecision(index) {
    if (!mobileDecisions.length) return;

    const nextIndex = Math.max(0, Math.min(index, mobileDecisions.length - 1));
    const decision = mobileDecisions[nextIndex];
    mobileDecisionIndex = nextIndex;

    if (appState.currentStep !== decision.step) {
        navigateToStep(decision.step);
    }

    const mobileFlowIsActive = isMobileDecisionFlowActive();
    mobileDecisions.forEach((item, itemIndex) => {
        const isActive = itemIndex === nextIndex;
        item.element.classList.toggle('active', isActive);
        if (mobileFlowIsActive) {
            item.element.setAttribute('aria-hidden', String(!isActive));
        } else {
            item.element.removeAttribute('aria-hidden');
        }
    });

    const copy = getMobileDecisionCopy();
    const decisionCopy = copy.decisions[decision.key];
    const activePanel = document.querySelector(`#step${decision.step} .left-panel`);
    const progress = activePanel ? activePanel.querySelector('.mobile-decision-progress') : null;
    const position = nextIndex + 1;
    const percent = Math.round((position / mobileDecisions.length) * 100);

    if (progress && decisionCopy) {
        progress.querySelector('.mobile-decision-progress__count').textContent = `${copy.step} ${String(position).padStart(2, '0')} / ${String(mobileDecisions.length).padStart(2, '0')}`;
        progress.querySelector('.mobile-decision-progress__percent').textContent = `${percent}%`;
        progress.querySelector('.mobile-decision-progress__fill').style.width = `${percent}%`;
        progress.querySelector('.mobile-decision-progress__title').textContent = decisionCopy[0];
        progress.querySelector('.mobile-decision-progress__hint').textContent = decisionCopy[1];
    }

    if (activePanel) {
        activePanel.scrollTo({ top: 0, behavior: 'auto' });
    }

    updateMobileFooter();
}

function setupMobileDecisionFlow() {
    buildMobileDecisionPanels();
    const toolScope = document.querySelector('.neon-tool-scope');
    if (toolScope) {
        toolScope.classList.add('has-guided-mobile-flow');
        bindGuidedViewportStability(toolScope);
    }
    createMobileDecisionHeaders();
    activateMobileDecision(0);

    const backButton = document.getElementById('mobileBackBtn');
    if (backButton && !backButton.dataset.mobileDecisionBound) {
        backButton.dataset.mobileDecisionBound = 'true';
        backButton.addEventListener('click', () => {
            if (!isMobileDecisionFlowActive() || mobileDecisionIndex === 0) return;

            const activePanel = document.querySelector('.left-panel.expanded');
            if (activePanel) {
                collapsePanel(activePanel, document.getElementById('mobileOverlay'));
            }
            activateMobileDecision(mobileDecisionIndex - 1);
            stabilizeGuidedDesignerViewport({ dismissKeyboard: true });
        });
    }
}

function setupMobileBottomSheet() {
    const leftPanels = document.querySelectorAll('.left-panel');
    const overlay = createMobileOverlay();
    const mobileFooter = createMobileFooter();

    setupMobileDecisionFlow();



    overlay.addEventListener('click', () => {
        const activePanel = document.querySelector('.left-panel.expanded');
        if (activePanel) {
            collapsePanel(activePanel, overlay);
        }
    });


    updateMobileFooter();
    setupScrollIndicator();
}

function setupScrollIndicator() {
    const isMobile = () => window.innerWidth < 1200;
    const scrollIndicator = document.querySelector('.scroll-indicator');
    if (!scrollIndicator) return;

    const toggleActivePanel = () => {
        if (!isMobile()) return;
        const activeContainer = document.querySelector('.step-container.active');
        const panel = activeContainer ? activeContainer.querySelector('.left-panel') : null;
        if (!panel) return;

        const overlay = document.getElementById('mobileOverlay');
        if (panel.classList.contains('expanded')) {
            collapsePanel(panel, overlay);
        } else {
            expandPanel(panel, overlay);
        }
    };

    scrollIndicator.setAttribute('role', 'button');
    scrollIndicator.setAttribute('tabindex', '0');
    scrollIndicator.addEventListener('click', toggleActivePanel);
    scrollIndicator.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleActivePanel();
        }
    });

    syncMobilePanelToggle(false);
}

function syncMobilePanelToggle(isExpanded) {
    const footer = document.getElementById('mobileFooter');
    const scrollIndicator = footer ? footer.querySelector('.scroll-indicator') : null;
    if (!footer || !scrollIndicator) return;

    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    const label = isExpanded
        ? (isFrench ? 'Afficher l\u2019aper\u00e7u de l\u2019enseigne' : 'Show sign preview')
        : (isFrench ? 'Afficher toutes les options' : 'Show all options');

    footer.classList.toggle('panel-expanded', isExpanded);
    scrollIndicator.setAttribute('aria-expanded', String(isExpanded));
    scrollIndicator.setAttribute('aria-label', label);

    const labelElement = scrollIndicator.querySelector('.scroll-indicator-label');
    if (labelElement) {
        labelElement.textContent = label;
    }
}

function createMobileOverlay() {
    let overlay = document.getElementById('mobileOverlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'mobile-panel-overlay';
        overlay.id = 'mobileOverlay';
        document.body.appendChild(overlay);
    }
    return overlay;
}

function createMobileFooter() {
    let neoncontainer = document.querySelector('.neon-generator-container');
    let footer = document.getElementById('mobileFooter');
    if (!footer) {
        footer = document.createElement('div');
        footer.className = 'mobile-footer';
        footer.id = 'mobileFooter';
        footer.innerHTML = `
            <div class="scroll-indicator" role="button" tabindex="0" aria-expanded="false" aria-label="Show all options">
                <span class="scroll-indicator-label">Show all options</span>
                <svg xml:space="preserve" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="arrow" id="Layer_1"
                    version="1.1" style="display:block;shape-rendering:auto; " preserveAspectRatio="xMidYMid meet" width="200"
                    height="200">
                    <style>
                        @keyframes animate {
                            0% {
                                transform: matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1);
                            }

                            50% {
                                transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                            }

                            100% {
                                transform: matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1);
                            }
                        }
                    </style>
                    <g class="ldl-scale" style="transform-origin:50% 50%;transform:rotate(0deg) scale(1,1)">
                        <g class="ldl-ani">
                            <g class="ldl-layer">
                                <g class="ldl-ani"
                                    style="transform-origin:50px 50px;animation:1s linear -0.75s infinite normal forwards running animate;transform-box:view-box">
                                    <path fill="#ffffff"
                                        d="M50 25.93c.53 0 1.061.213 1.451.638L84.612 52.41h5.916c1.713 0 2.608-2.036 1.451-3.298L51.451 15.235A1.961 1.961 0 0 0 50 14.597c-.53 0-1.061.213-1.451.638L8.021 49.112c-1.157 1.262-.262 3.298 1.451 3.298h5.916l33.161-25.842c.39-.425.921-.638 1.451-.638z"
                                        style="stroke-width:1"></path>
                                </g>
                            </g>
                            <g class="ldl-layer">
                                <g class="ldl-ani"
                                    style="transform-origin:50px 50px;animation:1s linear -1s infinite normal forwards running animate;transform-box:view-box">
                                    <path fill="#ffffff"
                                        d="M50 58.923c.53 0 1.061.213 1.451.638l33.161 25.842h5.916c1.713 0 2.608-2.036 1.451-3.298L51.451 48.228A1.961 1.961 0 0 0 50 47.59c-.53 0-1.061.213-1.451.638L8.021 82.104c-1.157 1.262-.262 3.298 1.451 3.298h5.916L48.549 59.56c.39-.424.921-.637 1.451-.637z"
                                        style="stroke-width:1"></path>
                                </g>
                            </g>
                            <metadata xmlns:d="https://loading.io/stock/"></metadata>
                        </g>
                    </g>
                </svg>
            </div>
            <div class="mobile-footer-content">
                <button class="mobile-back-btn" id="mobileBackBtn" type="button" aria-label="Back">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span>Back</span>
                </button>
                <div class="mobile-price-summary">
                    <div class="mobile-price-label">Total Price</div>
                    <div class="mobile-price-value">$${appState.discountPrice.toFixed(2)}</div>
                </div>
                <button class="mobile-action-btn" id="mobileNextBtn">
                    Next
                </button>
            </div>
        `;
        neoncontainer.appendChild(footer);


        const mobileNextBtn = footer.querySelector('#mobileNextBtn');
        mobileNextBtn.addEventListener('click', handleMobileNavigation);
    }
    syncMobileFooterHeight(footer);
    return footer;
}

function syncMobileFooterHeight(footer = document.getElementById('mobileFooter')) {
    const toolScope = document.querySelector('.neon-tool-scope');
    if (!footer || !toolScope) return;

    requestAnimationFrame(() => {
        toolScope.style.setProperty('--ens-mobile-footer-height', `${footer.offsetHeight}px`);
    });
}

function expandPanel(panel, overlay) {
    panel.classList.add('expanded');
    if (overlay) {
        overlay.classList.add('active');
    }
    syncMobilePanelToggle(true);
    document.body.style.overflow = 'hidden';
}

function collapsePanel(panel, overlay) {
    panel.classList.remove('expanded');
    if (overlay) {
        overlay.classList.remove('active');
    }
    panel.style.transform = '';
    syncMobilePanelToggle(false);
    document.body.style.overflow = '';
}

function handleMobileNavigation() {
    const currentStep = appState.currentStep;
    const activePanel = document.querySelector('.left-panel.expanded');
    const overlay = document.getElementById('mobileOverlay');

    if (isMobileDecisionFlowActive()) {
        const decisionKey = mobileDecisions[mobileDecisionIndex]?.key;
        if (decisionKey === 'text' && !validateSignText({ focus: true })) return;
        if (decisionKey === 'size' && !validateCustomSize({ focus: true })) return;
        if (activePanel) collapsePanel(activePanel, overlay);

        if (mobileDecisionIndex < mobileDecisions.length - 1) {
            activateMobileDecision(mobileDecisionIndex + 1);
            stabilizeGuidedDesignerViewport({ dismissKeyboard: true });
        } else {
            stabilizeGuidedDesignerViewport({ dismissKeyboard: true });
            showPreviewModal();
        }
        return;
    }

    if (activePanel) collapsePanel(activePanel, overlay);

    if (currentStep < 4) {
        navigateToStep(currentStep + 1);
    } else {

        showPreviewModal();
    }
}

function updateMobileFooter() {
    const footer = document.getElementById('mobileFooter');
    if (!footer) return;

    const priceValue = footer.querySelector('.mobile-price-value');
    const priceLabel = footer.querySelector('.mobile-price-label');
    const backButton = footer.querySelector('#mobileBackBtn');
    const actionBtn = footer.querySelector('#mobileNextBtn');

    if (priceValue) {
        priceValue.textContent = `$${appState.discountPrice.toFixed(2)}`;
    }

    if (isMobileDecisionFlowActive()) {
        const copy = getMobileDecisionCopy();
        const isLastDecision = mobileDecisionIndex === mobileDecisions.length - 1;

        if (priceLabel) {
            priceLabel.textContent = copy.total;
        }
        if (backButton) {
            backButton.disabled = mobileDecisionIndex === 0;
            backButton.classList.toggle('is-hidden', mobileDecisionIndex === 0);
            backButton.setAttribute('aria-label', copy.back);
            const backLabel = backButton.querySelector('span');
            if (backLabel) backLabel.textContent = copy.back;
        }
        if (actionBtn) {
            actionBtn.textContent = isLastDecision ? copy.review : copy.continue;
        }
    } else if (actionBtn) {
        if (appState.currentStep === 4) {
            actionBtn.textContent = getDesignerCopy().previewAndBuy;
        } else {
            actionBtn.textContent = getDesignerCopy().next;
        }
    }

    syncMobileFooterHeight(footer);
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileBottomSheet);
} else {
    setupMobileBottomSheet();
}


const originalNavigateToStep = navigateToStep;
navigateToStep = function (stepNumber) {
    // Store expanded state before navigation
    const isMobile = window.innerWidth < 1200;
    let wasExpanded = false;
    if (isMobile) {
        const currentContainer = document.querySelector('.step-container.active');
        wasExpanded = currentContainer && currentContainer.querySelector('.left-panel.expanded');
    }

    originalNavigateToStep(stepNumber);
    updateMobileFooter();

    // Reset scroll indicator visibility on step change (mobile only)
    if (isMobile) {
        const scrollIndicator = document.querySelector('.scroll-indicator');
        if (scrollIndicator) {
            scrollIndicator.style.display = '';
        }
        syncMobilePanelToggle(false);
    }

    // Preserve expanded state after navigation
    if (isMobile && wasExpanded) {
        const newActiveContainer = document.querySelector('.step-container.active');
        const newLeftPanel = newActiveContainer ? newActiveContainer.querySelector('.left-panel') : null;
        if (newLeftPanel) {
            setTimeout(() => {
                expandPanel(newLeftPanel, document.getElementById('mobileOverlay'));
            }, 50);
        }
    }
};


const originalRecalculateTotalPrice = recalculateTotalPrice;
recalculateTotalPrice = function () {
    originalRecalculateTotalPrice();
    updateMobileFooter();
};

function setupArtworkQuoteRequest() {
    const modal = document.getElementById('scQuoteModal');
    const trigger = document.getElementById('scQuoteTrigger');
    const form = document.getElementById('scArtworkQuoteForm');
    const status = document.getElementById('scQuoteStatus');
    const success = document.getElementById('scQuoteSuccess');
    const reference = document.getElementById('scQuoteReference');
    if (!modal || !trigger || !form || !status || !success || !reference) return;

    let previousFocus = null;
    const closeButtons = modal.querySelectorAll('[data-sc-quote-close]');
    const closeModal = () => {
        modal.hidden = true;
        document.body.classList.remove('sc-quote-modal-open');
        previousFocus?.focus?.({ preventScroll: true });
    };
    const openModal = () => {
        previousFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('sc-quote-modal-open');
        modal.querySelector('input[name="name"]')?.focus();
    };

    trigger.addEventListener('click', openModal);
    closeButtons.forEach(button => button.addEventListener('click', closeModal));
    modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') closeModal();
    });

    const quoteRequested = new URLSearchParams(window.location.search).get('quote') === '1'
        || window.location.hash === '#request-neon-quote';
    if (quoteRequested) {
        window.setTimeout(openModal, 150);
    }

    form.addEventListener('submit', async event => {
        event.preventDefault();
        status.className = 'sc-quote-form__status';
        status.textContent = '';
        const fileInput = form.querySelector('input[type="file"]');
        const files = [...(fileInput?.files || [])];
        if (!files.length) {
            status.classList.add('is-error');
            status.textContent = 'Please attach at least one artwork or inspiration file.';
            fileInput?.focus();
            return;
        }
        if (files.length > 5 || files.some(file => file.size > 10 * 1024 * 1024)) {
            status.classList.add('is-error');
            status.textContent = 'Upload no more than five files, with each file 10 MB or smaller.';
            fileInput?.focus();
            return;
        }

        const submitButton = form.querySelector('button[type="submit"]');
        const originalLabel = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = 'Sending your request…';
        status.textContent = 'Uploading your artwork securely…';

        try {
            const apiBaseUrl = (window.scNeonConfig?.apiBaseUrl || '').replace(/\/$/, '');
            const apiKey = window.scNeonConfig?.apiKey || '';
            if (!apiBaseUrl || !apiKey) throw new Error('The quote service is not configured.');
            const response = await fetch(`${apiBaseUrl}/request-artwork-quote`, {
                method: 'POST',
                headers: {
                    'X-API-Key': apiKey,
                    'X-Idempotency-Key': `artwork-quote-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
                },
                body: new FormData(form)
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(data.detail || 'We could not send your request. Please try again.');
            form.hidden = true;
            success.hidden = false;
            reference.textContent = data.quote_reference ? `Quote reference: ${data.quote_reference}` : '';
        } catch (error) {
            status.classList.add('is-error');
            status.textContent = error.message || 'We could not send your request. Please try again.';
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = originalLabel;
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupArtworkQuoteRequest);
} else {
    setupArtworkQuoteRequest();
}
